<template>
<div class="privacy-body">
  <info-header/>
  <div class="jm-protocol">
    <p class="title">京东金融隐私政策</p>
    <p class="text">
      本政策仅适用于京东科技控股股份有限公司及其关联公司（以下或称“我们”或“京东金融”）提供的产品和服务及其延伸的功能（以下简称“京东金融服务”），包括京东金融APP、京东金融官方网站https://www.jdt.com.cn/finance/。有关京东金融的更多信息，请您访问京东金融官方网站中“常见问题-<a
        href="https://jrhelp.jd.com/show/getProblemInfo-688"
        >京东金融简介</a
      >”部分。如我们提供的某款产品有单独的隐私政策或相应的用户服务协议当中存在特殊约定，则该产品的隐私政策将优先适用；该款产品隐私政策和用户服务协议未涵盖的内容，以本政策内容为准。
    </p>
    <p class="text">版本更新日期：2022年4月24日</p>
    <p class="text">版本生效日期：2022年4月30日</p>
    <p class="text">
      如您有任何疑问、意见或建议，您可通过以下联系方式与我们联系：
    </p>
    <p class="text">联系电话：95118</p>
    <p class="text">联系邮箱：finance-cs@jd.com</p>
    <p class="text">注册地址：北京市经济开发区科创十一街18号</p>
    <p class="text">常用办公地址：北京市经济开发区科创十一街18号</p>
    <p class="text">&nbsp;</p>
    <p class="text strong">引言</p>
    <p class="text strong">
      我们非常重视用户的隐私和个人信息保护。您在使用我们的产品与/或服务时，我们可能会收集和使用您的信息。我们希望通过《京东金融隐私政策》（“本政策”）向您说明我们的业务情形和对应需要收集您个人信息的类型，以及我们为您提供访问、更新、删除这些信息的途径和保护措施，还有当我们共享、转让、公开披露您个人信息时需要遵守的规则。本政策与您所使用的京东金融服务以及该服务所包括的各种业务功能（以下统称“我们的产品与/或服务”）息息相关，希望您在使用我们的产品与/或服务前仔细阅读并确认您已经充分理解本政策所写明的内容（特别是加粗字体的内容），并让您可以按照本政策的指引做出您认为适当的选择。本政策中涉及的<a
        href="#_十一、本政策中关键词定义"
        >相关术语</a
      >，我们用简明扼要的表述，以便您更好地理解。
    </p>
    <p class="text">&nbsp;</p>
    <p class="text strong">
      需要特别说明的是，本政策仅适用于本政策定义的产品与/或服务。当您使用第三方机构直接向您提供的产品或服务并向其提供您的个人信息时，我们建议您在使用之前仔细查看他们的隐私政策，了解他们如何处理您的信息，以便审慎决策。
    </p>
    <p class="text">&nbsp;</p>
    <p class="text strong">目录</p>
    <p class="text">一、我们如何收集您的个人信息</p>
    <p class="text">二、我们如何使用您的个人信息</p>
    <p class="text">三、我们如何使用Cookie和同类技术</p>
    <p class="text">四、我们如何委托处理共享、转让、公开披露您的个人信息</p>
    <p class="text">五、我们如何保护您的个人信息</p>
    <p class="text">六、您的权利</p>
    <p class="text">七、我们如何处理儿童的个人信息</p>
    <p class="text">八、您的个人信息如何在全球范围转移</p>
    <p class="text">九、本政策如何更新</p>
    <p class="text">十、如何联系我们</p>
    <p class="text">十一、本政策中关键词定义</p>
    <p class="text">&nbsp;</p>
    <p class="text strong">
      <a id="_一、我们如何收集和使用您的个人信息"></a
      >一、我们如何收集您的个人信息
    </p>
    <p class="text">
      我们会遵循正当、合法、必要的原则，出于本政策所述的以下目的，收集和使用您在使用产品与/或服务过程中主动提供或因使用产品与/或服务而产生的个人信息，以及从第三方获取您的相关个人信息。<span
        class="strong"
        >如果我们要将您的个人信息用于本政策未载明的其它用途，或将基于特定目的收集而来的信息用于其他目的，我们将以合理的方式向您告知，并在使用前再次征得您的同意。</span
      >
    </p>
    <p class="text strong">（一）我们如何收集您的信息</p>
    <p class="text">我们会通过如下三种渠道获取您的个人信息：</p>
    <p class="text">
      <span class="strong">1、您直接提供的信息：</span
      >我们可能收集并存储您在使用京东金融服务时向我们提供的信息，包括您在我们页面中在线填写信息时、申请产品与/或服务时、参与网络社区讨论时、解决争议或就京东金融服务与我们联系时所<span
        class="strong"
        >提供的信息</span
      >，以及您在使用我们服务过程中<span class="strong"
        >产生的关于您的交易和活动的信息。</span
      >
    </p>
    <p class="text">
      <span class="strong">2、我们主动收集的信息：</span
      >在您使用京东金融网站、APP及相关服务过程中，我们会收集您的计算机、手机及其他访问设备发送给我们的信息。
    </p>
    <p class="text">
      <span class="strong">3、我们从其他来源取得的信息：</span
      >在取得您同意的前提下，我们还可能从京东金融关联公司及合作伙伴、信用机构及依法成立并合法留存您的相关信息的第三方机构获取您的相关信息。
    </p>
    <p class="text strong">（二）我们收集您的哪些信息</p>
    <p class="text">
      在实现京东金融以下各项业务功能的过程中，我们需要收集您的一些信息，用以向您提供服务、提升我们的服务质量、保障您的账号和资金安全以及符合国家法律法规及监管规定。<span
        class="strong"
        >请您注意，如果您提供的是他人个人信息，请您确保已取得相关主体的授权。</span
      >
    </p>
    <p class="text strong">1、账号注册与登录</p>
    <p class="text">
      京东金融中的账号登录服务由我们的关联公司北京京东叁佰陆拾度电子商务有限公司（以下简称“京东叁佰陆拾度”）提供，您需要注册京东账号登录京东金融。在此过程中，为对您的账号进行验证以实现登录目的，京东叁佰陆拾度将按照《京东隐私政策》的约定收集、存储您的<span
        class="strong"
        >京东账号名、密码、手机号码</span
      >用于账号注册与登录的基础账号信息和您自行选择补充提供的<span
        class="strong"
        >头像、昵称</span
      >等其他账号信息，请您在使用京东账号登录功能前仔细阅读<a
        href="https://in.m.jd.com/help/app/register_info.html"
        >《京东用户注册协议》</a
      >、<a href="https://in.m.jd.com/help/app/private_policy.html"
        >《京东隐私政策》</a
      >项下的相关内容。同时，在您使用京东账号登录京东金融的过程中，为将您的京东账号与您在京东金融上的操作行为相关联，我们将向京东叁佰陆拾度收集您的京东账号信息，包括<span
        class="strong"
        >京东账号名、手机号码、昵称、头像</span
      >，收集这些信息是用于为您提供账号登录服务以及保障您的账号安全，若您不提供上述信息，则您无法正常登录京东金融。但不影响您浏览京东金融的产品/服务。
    </p>
    <p class="text strong">2、实名认证</p>
    <p class="text">
      在您使用理财服务、信贷服务、保险服务、支付服务、信用卡还款服务时：
    </p>
    <p class="text">
      （1）依据《中华人民共和国反洗钱法》、《中华人民共和国反恐怖主义法》、《互联网金融从业机构反洗钱和反恐怖融资管理办法》、《支付机构反洗钱和反恐怖融资管理办法》及其他法律法规要求，为了履行反洗钱、反恐怖融资义务，我们需要验证您身份的真实性，您需要提供身份基本信息<strong>（姓名、性别、国籍、职业、住所地或者工作单位地址、手机号、身份证件或者身份证明文件的种类、号码和有效期限信息）</strong>；身份基本信息中包含您的个人敏感信息，如您不提供前述信息，可能无法使用上述服务。但不影响您使用我们提供的其他服务。
    </p>
    <p class="text">
      （2）依据《公开募集证券投资基金销售机构监督管理办法》及反洗钱法规、在发生法律法规及监管规定的特定情形时，还需要您提供<strong>身份证件彩色照片或影印件</strong>以供我们核对并留存。
    </p>
    <p class="text">
      （3）根据相关法律法规的规定，您需通过身份基本信息多重交叉验证后方可使用大额支付、使用账户余额购买投资理财、使用信贷服务等金融类产品。在进行多重身份验证时，若通过绑定银行卡进行身份实名认证的，获取您授权的前提下，我们还需要您提供<strong>银行卡信息和银行预留手机号</strong>；前述信息属于您的个人敏感信息，如您不提供前述信息，可能无法使用需要通过多重交叉验证后方可使用的部分服务，但不影响您使用我们提供的其他服务。
    </p>
    <p class="text">
      （4）若您选择刷脸认证方式进行实名验证时，获取您授权的前提下，我们需要您提供<strong>面部信息完成实名验证，前述信息属于您的个人敏感信息，如果您不提供面部信息，则无法使用刷脸认证方式进行实名验证</strong>，但您可以通过其他方式验证。
    </p>
    <p class="text" style="text-indent: 2em;">为了验证您提交实名信息的真实性、准确性，我们会将您提供的信息与合法存储您信息的外部验证渠道（包括政府部门数据库、商业银行信息系统和商业化数据库等）核验，以核实您提供的信息真实性和准确性。为提升您的服务体验、如果您在使用我们的关联公司服务的过程当中留存过前述信息，我们可能会通过我们的关联公司进行信息收集，以免您重复提交。
    </p>
    <p class="text strong">3、信贷服务功能</p>
    <p class="text">
      <strong
        >您在使用京东金融信贷服务，包括白条、金条、借钱服务、抵押贷款服务、分期服务、小白卡、时，根据您所选择的服务，您需要自主填写或提交您的实名认证信息、教育信息、财产信息、婚姻状态、联系人信息，我们还会收集还款金额、订单号、订单状态</strong
      >。这些信息将被用来对您的信贷资格、信用及偿付能力进行审核以及为您提供还款服务，帮助我们做好风险管理和客户服务工作。如果您不提供上述信息，我们则无法向您提供信贷服务，但不影响您使用其他产品/服务。
    </p>
    <p class="text strong">4、支付服务功能</p>
    <p class="text">
      （1）您在使用京东金融支付服务功能，包括京东支付、京东闪付、京东钱包、转账、信用卡还款、红包、扫一扫、付款码、支付优惠时，<strong>根据您使用不同的支付功能</strong>，我们可能会使用您的<strong>实名认证信息、京东账号、开户行、银行卡号、银行预留手机号、银行卡有效期、订单信息、交易记录、转账记录、银行卡支付方式、支付渠道、持卡人信息，持卡人证件</strong>为您提供支付服务，如您不提供上述信息，我们无法提供支付相关服务或功能。
    </p>
    <p class="text">
      （2）如您使用刷脸支付、指纹支付方式时，获取您授权的前提下，我们可能会收集您的<strong>面部信息、指纹验证结果信息</strong>，前述信息属于您的个人敏感信息，如您不提供前述信息，则您无法使用刷脸支付功能/指纹支付功能，如您不想使用刷脸验证、指纹验证支付方式，仍可通过其他方式支付。
    </p>
    <p class="text strong">5、理财服务、保险服务功能</p>
    <p class="text">
      （1）在您使用理财服务、保险服务（如基金产品、券商集合产品、保险产品等）时，根据您所选择的服务，我们会收集您的实名认证信息、持仓信息、理财金信息，这些信息将被用来对您提供持仓查询、账户信息管理服务，如您不提供上述信息，我们无法提供相关理财持仓查询、账户服务或功能。但不影响您使用我们提供的其他服务。
    </p>
    <p class="text">
      （2）如您使用股票交易服务，在您进行证券登录交易时，根据《关于加强证券期货经营机构客户交易终端信息等客户信息管理的规定》规定，需要收集您的Mac地址、IDFV、IP、注册手机号和实际使用手机号，
      如您不提供上述信息，则无法使用股票服务，但不影响您使用我们的其他服务。
    </p>
    <p class="text">
      （3）如您使用期货交易服务，在您进行期货登录交易时，根据《关于加强证券期货经营机构客户交易终端信息等客户信息管理的规定》规定，需要收集您的Mac地址、IMEI、IDFV、IP、设备序列号、<strong>精确地理位置信息</strong>、MEID
      、ICCID、实际使用手机号，
      如您不提供上述信息，则无法使用期货服务，但不影响您使用我们的其他服务。
    </p>
    <p class="text strong">6、保障账户安全、交易安全所必须的功能</p>
    <p class="text">
      为保障您使用我们的产品与/或服务时系统的稳定性和安全性，履行反洗钱、反恐怖融资法律法规的要求，防止您的个人信息被非法获取，预防交易和资金风险、预防欺诈、病毒或其他恶意程序，保护账号及交易安全，我们需要收集您的<strong
        >设备信息（设备型号、设备Mac地址、Wifi Mac
        地址、应用进程列表、设备识别码、操作系统及软件版本、设备状态、网络状况、设备分辨率、ssid）、Wifi信息、任务列表、已安装应用列表、历史上网记录、日志信息、面部信息、IP地址、音乐、位置信息来判断您的账号风险，</strong
      >并可能会记录一些我们认为有风险的链接（“URL”）；使用您的设备信息用于对京东金融系统问题进行分析、统计流量并排查可能存在的风险，在您选择向我们发送异常信息时予以排查。如果您不提供上述信息，我们则无法在您使用京东金融服务过程中对您的服务及账号安全进行保护。
    </p>
    <p class="text strong">7、客户服务功能</p>
    <p class="text">
      为保证您的账号安全，我们的呼叫中心客服和在线客服会使用您的<strong>账号信息</strong>与您核验您的身份。当您需要我们提供与您交易信息相关的客服与售后服务时，我们将会查询您的<strong>交易信息</strong>。为了保障服务质量，我们可能需要对客服电话内容进行录音；在录音开始前我们会向您进行必要的提示，充分保障您的知情权与选择权；前述信息属于您的个人敏感信息。此外，我们还会收集您与客服联系时<strong>您反馈意见、建议或举报时提供的信息</strong>，您<strong>参与问卷调查时向我们发送的信息</strong>。如您不提供前述信息，不影响您使用我们提供的其他服务。
    </p>
    <p class="text strong">8、广告功能</p>
    <p class="text">
      为更好地向用户提供服务，我们还可能通过站内信、PUSH通知、手机短信、电话方式向您推送我们认为您可能会感兴趣的广告和其它商业信息，如您不想收到此类广告的通知，可以根据本政策第六大部分第（五）节进行退订。
    </p>
    <p class="text">
      为了向您提供更契合您需求的服务，我们可能会将您的注册信息、<strong>交易信息</strong>、<strong>浏览信息</strong>、关注的信息和我们在您使用金融APP时采集的您的个人信息进行关联并进行数据分析以形成客户画像，用来向您推荐您感兴趣的产品和/或服务。如果您不想收到个性化推荐内容，您可以根据本政策第六部分第（五）节的描述关闭相关功能。
    </p>
    <p class="text strong">9、车主服务</p>
    <p class="text">
      在您使用车主服务，包括ETC、违章查询、限行查询、年检服务、驾照更新时，根据您所选择的服务，我们可能会收集您的车牌号、车辆识别码、发动机号、注册日期、车型、行驶里程、年均里程等信息，这些信息将被用来对您提供车辆管理、证照管理等服务，如您不提供上述信息，我们将无法提供车主相关服务或功能。但不影响您使用其他服务。
    </p>
    <p class="text strong">
      （三）我们通过第三方主体或使用第三方服务时间接收集您信息
    </p>
    <p class="text">
      1、我们可能会在您的授权同意范围内从第三方（我们的合作方）处收集并使用您的个人信息。<strong>我们保证严格依照与第三方签订的合同以及相关法律规定处理您的个人信息，同时请您详细阅读该第三方的隐私政策及用户协议。</strong>如您拒绝第三方在提供服务时收集、使用或者传递您的个人信息，将可能导致您无法使用相应的服务。
    </p>
    <p class="text">
      2、第三方登录：当您使用经授权的第三方帐号（如Apple、微信）登录帐号时，如果您决定绑定京东账号，我们会在征得您的同意后，从第三方获取您的相关个人信息。该第三方帐号可能需要收集您的个人信息，例如<strong>设备标识符</strong>。您在第三方帐号设置的<strong>昵称、头像</strong>信息可能被用作帐号的昵称和头像。您也可以使用<strong>本机号码</strong>来快捷登录，我们会将您的网络信息提供给运营商完成注册或登录。
    </p>
    <p class="text">
      3、信贷服务：在取得您同意的前提下，我们可能从合法持有您个人信息的第三方机构获得您的征信信息、违法犯罪记录、贷款信息、收入情况，用于对您的信贷资格、信用及偿付能力进行审核、并提供匹配的信贷服务。
    </p>
    <p class="text strong">
      （四）京东金融APP涉及嵌入第三方代码、插件传输个人信息的情形逐项列举，详见<a
        href="https://h5.m.jd.com/babelDiy/Zeus/2gA11VaUdCYknGCS2x6cLLJf8USZ/index.html"
        >个人信息共享清单</a
      >。
    </p>
    <p class="text strong">（五）设备权限调用说明</p>
    <p class="text">
      在您使用我们的产品和/服务时，我们可能需要向您申请下列与个人信息相关的系统敏感权限：
    </p>
    <p class="text strong">1、权限名称：读取电话状态权限</p>
    <p class="text">权限功能说明：识别您的本机识别码</p>
    <p class="text">
      使用场景或目的：当您运行Android版本京东金融APP时，我们会向您申请获取此权限，目的是正常识别您的本机识别码，以便完成安全风控、进行统计和服务推送。若您不想接收相关推送信息，可以根据本政策指引进行关闭。
    </p>
    <p class="text strong">2、权限名称：读写外部存储权限</p>
    <p class="text">权限功能说明：使用或保存图片、视频或文件</p>
    <p class="text">
      使用场景或目的：当您使用Android版本京东金融APP中的扫一扫、头像设置、客服、评论或分享、图像识别、将文件下载至本地或打开使用本地文件时，您可以通过开启存储权限使用或保存图片、视频或文件。若您不开启此权限，您将无法使用与存储卡读取或缓存相关的功能，但不影响您使用其他服务。
    </p>
    <p class="text strong">3、权限名称：相册权限</p>
    <p class="text">权限功能说明：社区评论或注册更改头像及相册添加</p>
    <p class="text">
      使用场景或目的：当您使用IOS版本京东金融APP中的扫一扫、头像设置、客服、评论或分享、图像识别等服务时，您可以通过开通相册权限以便上传设备中的图片或视频。若您不开启此权限，您将无法使用图片或视频上传相关的功能，但不影响您使用其他服务。
    </p>
    <p class="text strong">4、权限名称：相机权限</p>
    <p class="text">权限功能说明：扫码、拍摄</p>
    <p class="text">
      使用场景或目的:
      当您使用Android或IOS版本京东金融APP中的扫一扫、头像设置、客服、评论或分享、图像识别等服务时，您可以通过开通相机权限以便进行实时拍摄并上传图片或视频进行晒图或分享、设置头像。在需要人脸识别的场景下，则需要调用您的摄像头进行<span
        class="strong"
        >人脸的拍摄</span
      >。若您不开启此权限，您将无法使用图片或视频拍摄相关的功能，但不影响您使用其他服务。
    </p>
    <p class="text strong">5、权限名称：位置权限</p>
    <p class="text">权限功能说明：获取当前所在位置</p>
    <p class="text">
      使用场景或目的:
      当您使用Android或IOS版本京东金融APP中的本地生活服务、搜索周边商家或优惠、限定销售区域的金融产品时，您可以通过开启位置权限以便查看或获取当前所在区域的服务。若您不开启此权限，您将无法收到基于当前所在位置进行的推荐，但不影响您使用其他服务。
    </p>
    <p class="text strong">6、权限名称：麦克风权限</p>
    <p class="text">权限功能说明：录音</p>
    <p class="text">
      使用场景或目的：当您使用Android或IOS版本京东金融APP中的语音搜索或语音客服服务时，您可以开启麦克风权限点击语音按钮进行录音，以便我们收集您的语音内容并进行必要的处理。若您不开启此权限，您将无法使用语音输入相关的功能，但不影响您使用其他服务。
    </p>
    <p class="text strong">7、权限名称：日历权限</p>
    <p class="text">权限功能说明：编辑、添加您关注的活动等日程</p>
    <p class="text">
      使用场景或目的：当您使用京东金融APP中的活动提醒功能或IOS版本京东金融APP中的早起打卡服务时，您可以通过开启日历权限便捷管理您的自定义事项、设定重要事项提醒。若您不开启此权限，您将无法使用日历管理相关的功能，但不影响您使用其他服务。
    </p>
    <p class="text strong">8、权限名称：面容ID/触控ID权限</p>
    <p class="text">权限功能说明：访问面容信息或指纹信息</p>
    <p class="text">
      使用场景或目的：若您使用支持人脸识别的苹果设备，您可以使用京东金融APP中的面容ID支付、面容ID解锁功能；若您使用支持指纹识别的苹果设备，您可以使用京东金融APP中的指纹支付、指纹解锁功能。您需要在您的设备上提前录入面容信息或指纹信息，并在使用服务时在您的设备上完成信息验证。我们需要使用您的面容ID/触控ID权限以便接收<span
        class="strong"
        >验证结果</span
      >，但我们并不收集您的面容ID/触控ID信息。若您不开启此权限，您将无法使用前述服务，但不影响您选择其他支付或解锁方式。
    </p>
    <p class="text strong">9、权限名称：蓝牙权限</p>
    <p class="text">权限功能说明：使用蓝牙权限</p>
    <p class="text">
      使用场景或目的：当您使用Android版本京东金融APP中的京东闪付手环功能时，若要在京东金融APP中进行计步查看、公交卡设置、闪付卡设置，需要您开启蓝牙权限搜索周边设备，以便您的手环能够与京东金融APP建立正常连接。若您不开启此权限，您将无法使用手环相关的功能，但不影响您使用其他服务。
    </p>
    <p class="text strong">10、权限名称：悬浮窗</p>
    <p class="text">权限功能说明：使用悬浮窗权限</p>
    <p class="text">
      使用场景或目的：当您使用第三方APP唤起京东金融APP后，再返回第三方APP时，以及使用社区直播业务，在其他页面播放直播功能时需要使用该权限。
    </p>
    <br />
    <p class="text">
      我们申请获取的权限将与提供的服务功能保持一致，若我们提供的业务功能调整，我们申请的设备权限也将随之调整。我们在首次调用设备权限时会单独提示您是否开启并对权限申请目的进行解释。<span
        class="strong"
        >请您注意，您开启这些权限即代表您授权我们可以收集和使用这些个人信息来实现上述的功能，您关闭权限即代表您取消了这些授权，则我们将不再继续收集您的这些个人信息，也无法为您提供上述与这些授权所对应的功能。您关闭权限的决定不会影响此前基于您的授权所进行的个人信息的处理</span
      >。除此以外，我们在相关业务功能中可能还需要您开启设备的其他访问权限，详见<a
        href="https://h5.m.jd.com/babelDiy/Zeus/TCJjHuGRGC6r2PtgJCskez83QcV/index.html"
        >应用权限申请与使用情况说明</a
      >。
    </p>
    <p class="text strong">（六）征得授权同意的例外</p>
    <p class="text">
      依据相关法律法规及国家标准，以下情形中，我们可能会依法收集并使用您的个人信息无需征得您的同意：
    </p>
    <p class="text">1、与国家安全、国防安全直接有关的；</p>
    <p class="text">2、与公共安全、公共卫生、重大公共利益直接有关的；</p>
    <p class="text">3、与犯罪侦查、起诉、审判和判决执行等直接有关的；</p>
    <p class="text">
      4、出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；
    </p>
    <p class="text">5、所收集的个人信息是个人信息主体自行向社会公众公开的；</p>
    <p class="text">6、从合法公开披露的信息中收集的您的个人信息的；</p>
    <p class="text">7、根据您的要求签订和履行合同所必需的；</p>
    <p class="text">8、法律法规规定的其他情形。</p>
    <br />
    <p class="text strong"><a></a>二、我们如何使用您的个人信息</p>
    <p class="text">
      1、为了遵守国家法律法规及监管要求，以及向您提供服务及提升服务质量，或保障您的账号和资金安全，我们会在以下情形中使用您的信息：
    </p>
    <p class="text">（1）实现本政策“我们收集您的哪些信息”约定的目的。</p>
    <p class="text">
      （2）为了保障服务的稳定性与安全性，我们会将您的信息用于身份验证、安全防范、诈骗监测、预防或禁止非法活动、降低风险、存档和备份用途。
    </p>
    <p class="text">
      （3）为了使您知晓使用我们服务的状态，我们会向您发送服务提醒。
    </p>
    <p class="text">（4）根据法律法规或监管要求向相关部门进行报告。</p>
    <p class="text">（5）邀请您参与我们服务有关的客户调研。</p>
    <p class="text">（6）提高、完善和优化京东金融在线服务。</p>
    <p class="text">（7）处理您对京东金融产品与/或服务的申请或反馈请求。</p>
    <p class="text">
      （8）我们通过技术手段对数据进行去标识化处理后，去标识化处理的信息将无法识别主体。<strong
        >请您了解并同意，在此情况下我们有权使用已经去标识化的信息；在不透露您个人信息的前提下，我们有权对用户数据库进行分析并予以商业化的利用。</strong
      >
    </p>
    <p class="text">
      （9）我们会对我们的产品与/或服务使用情况进行统计，并可能会与公众或第三方共享这些统计信息，以展示我们的产品与/或服务的整体使用趋势。但这些统计信息不包含您的任何身份识别信息。
    </p>
    <p class="text">
      2、当我们展示您的个人信息时，我们会采用包括内容替换、匿名处理方式对您的信息进行脱敏展示，以保护您的信息安全。
    </p>
    <p class="text">
      3、当我们要将您的个人信息用于本政策未载明的其它用途时，或基于特定目的收集而来的信息用于其他目的时，会事先征求您的同意。<strong
        >请您理解，我们向您提供的产品与/或服务将不断更新变化。如果您选择使用本政策中尚未列明的其他产品与/或服务时，在我们收集您的个人信息前，我们会通过业务协议、页面提示的方式向您详细说明信息收集的目的、方式、范围并征求您的明确同意。若您不同意提供前述信息，您可能无法使用该项服务，但不影响您使用其他服务。</strong
      >
    </p>
    <br />
    <p class="text strong">三、我们如何使用Cookie和同类技术</p>
    <p class="text strong">（一）Cookie的使用</p>
    <p class="text">
      1、为使您获得更轻松的访问体验，我们有时会在您的计算机或移动设备上存储名为Cookie的小数据文件。Cookie
      是一种网络服务器存储在计算机或移动设备上的纯文本文件，其内容只能由创建它的服务器检索或读取。每个
      Cookie对您的网络浏览器或移动应用程序都是唯一的。Cookie
      通常包含标识符、站点名称以及一些号码和字符。借助于
      Cookie，网站能够记住用户的单次访问（使用会话 Cookie）或多次访问（使用永久
      Cookie）。借助于
      Cookie，网站能够保存设置，例如计算机或移动设备的语言、字体大小和其他浏览偏好。这意味着，用户无需在每次访问时重新配置用户偏好设置。如果某个网站不使用
      Cookie，那么在用户每一次打开网页时，该网站都会将其视为新访客。例如，如果您登录某个网站后转到另一个网页，该网站就不会识别出您，而您会被再次注销。
    </p>
    <p class="text">
      2、为了向您提供更为便捷、个性化的服务，我们通过Cookie等技术为您提供以下服务：
    </p>
    <p class="text">
      （1）记住您的账号。例如，当您访问一个需要您登录才可以提供的信息或服务，当您登录时，我们会把该您的登录名加密存储在您计算机的Cookie文件中，由于是不可逆转的加密存储，其他人即使可以使用该您的计算机，也无法识别出您的登录名。您并不需要额外做任何工作，所有的收集、保存和加密工作都由系统自动完成。Cookie可能帮助您省去为使用我们服务而重复输入账号的步骤。
    </p>
    <p class="text">
      （2）分析您使用我们服务的情况。例如，我们可通过Cookie、网络信标等技术来了解您使用我们服务的具体用途，或哪些网页或服务最受您的欢迎。
    </p>
    <p class="text">
      （3）广告优化。我们可能会根据您访问相关网站的统计信息为您显示您可能感兴趣的产品或广告信息。这些统计信息并不包括您的任何个人信息，这些信息可能被用来评估广告的有效度。Cookie、网络信标等技术有助于我们根据您的信息，向您提供与您相关的广告而非进行普遍的广告投放。
    </p>
    <p class="text">
      （4）我们也可能通过网络信标技术来统计匿名访问的数据，同样，这些统计信息并不包括您的个人信息。
    </p>
    <p class="text">
      3、我们不会将Cookie用于本政策所述目的之外的任何用途。您可以随时使用自带清除Cookie功能的浏览器或操作系统软件根据自己的偏好管理或删除Cookie。您可以清除计算机上保存的所有Cookie，大部分网络浏览器会自动接受Cookie，但您通常可根据自己的需要来修改浏览器的设置以拒绝Cookie或删除Cookie。但如果您这么做，您可能需要在每一次访问我们的网站时亲自更改用户设置，可能会对您所使用服务的安全性和便捷性有一定影响，但不影响您正常使用我们提供的其他服务。
    </p>
    <p class="text strong">（二）网络信标、像素标签等同类技术的使用</p>
    <p class="text">
      除Cookie外，我们还会在网站上使用网络信标和像素标签等其他同类技术。例如，我们向您发送的电子邮件可能含有链接至我们网站内容的点击URL。如果您点击该链接，我们则会跟踪此次点击，帮助我们了解您的产品和服务偏好并改善客户服务。网站信标通常是一种嵌入到网站或电子邮件中的透明图像。借助于电子邮件中的像素标签，我们能够获知电子邮件是否被打开。如果您不希望自己的活动以这种方式被追踪，则可以随时选择退订。
    </p>
    <br />
    <p class="text strong">
      四、我们如何委托处理、共享、转让、公开披露您的个人信息
    </p>
    <p class="text strong">（一）委托处理</p>
    <p class="text">
      为了提高效率、降低成本，我们可能会委托关联公司或其他专业服务提供商代表我们来处理信息，例如我们会聘请服务提供商为我们提供基础设施技术服务、信贷审批服务、客户支持服务。对我们委托处理个人信息的公司、组织和个人，我们会通过书面协议、现场审计等方式要求其遵守严格的保密义务并采取有效的保密措施，要求其只能在委托范围内处理您的信息，而不得出于其自身利益使用您的信息。
    </p>
    <p style="font-family: Calibri; font-size: 14px; white-space: normal">
      <strong
        ><span style="font-family: 微软雅黑; font-size: 14px"
          ><span style="font-family: 微软雅黑">（二）共享</span></span
        ></strong
      >
    </p>
    <p style="font-family: Calibri; font-size: 14px; white-space: normal">
      <strong
        ><span style="font-family: 微软雅黑; font-size: 14px"
          ><span style="font-family: 微软雅黑"
            >我们不会与京东金融以外的任何公司、组织和个人共享您的个人信息，</span
          ></span
        ></strong
      ><strong
        ><span style="font-family: 微软雅黑; font-size: 14px"
          ><span style="font-family: 微软雅黑">除非获得您的明确同意或属于</span
          >“</span
        ></strong>
        <strong>
          <span style="text-decoration: none"
            ><span
              style="
                font-family: 微软雅黑;
                font-size: 14px;
              "
              ><span style="font-family: 微软雅黑"
                >共享、转让、公开披露个人信息时事先征得授权同意的例外</span
              ></span
            ></span>
        </strong>
      <strong
        ><span style="font-family: 微软雅黑; font-size: 14px">”。</span></strong
      ><strong
        ><span style="font-family: 微软雅黑; font-size: 14px"
          ><span style="font-family: 微软雅黑">我们可能会向</span></span
        ></strong
      ><strong
        ><span style="font-family: 微软雅黑; font-size: 14px"
          ><span style="font-family: 微软雅黑">关联公司、</span></span
        ></strong
      ><strong
        ><span style="font-family: 微软雅黑; font-size: 14px"
          ><span style="font-family: 微软雅黑"
            >合作伙伴等第三方共享您的</span
          ></span
        ></strong
      ><strong
        ><span style="font-family: 微软雅黑; font-size: 14px"
          ><span style="font-family: 微软雅黑">个人信息</span></span
        ></strong
      ><strong
        ><span style="font-family: 微软雅黑; font-size: 14px"
          ><span style="font-family: 微软雅黑"
            >，以保障为您提供的服务顺利完成</span
          ></span
        ></strong
      ><strong
        ><span style="font-family: 微软雅黑; font-size: 14px"
          ><span style="font-family: 微软雅黑">；</span></span
        ></strong
      ><strong
        ><span style="font-family: 微软雅黑; font-size: 14px"
          ><span style="font-family: 微软雅黑"
            >但我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息</span
          ></span
        ></strong
      ><strong
        ><span style="font-family: 微软雅黑; font-size: 14px"
          ><span style="font-family: 微软雅黑">。该等第三方</span></span
        ></strong
      ><strong
        ><span style="font-family: 微软雅黑; font-size: 14px"
          ><span style="font-family: 微软雅黑"
            >无权将共享的个人信息用于任何其他用途。</span
          ></span
        ></strong
      ><span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑"
          >对我们与之共享个人信息的公司、组织和个人，我们会与其签署严格的保密协定，要求他们按照我们的协议、本政策要求的保密和安全措施来处理个人信息。在个人敏感数据使用上，我们要求第三方采用数据脱敏和加密技术，从而更好地保护用户数据。我们将按照法律法规及国家标准的要求以点击确认协议、具体场景下的点击确认动作等形式征求您的同意。</span
        ></span
      >
    </p>
    <p style="font-family: Calibri; font-size: 14px; white-space: normal">
      <strong
        ><span style="font-family: 微软雅黑; font-size: 14px">1、</span></strong
      ><strong
        ><span style="font-family: 微软雅黑; font-size: 14px"
          ><span style="font-family: 微软雅黑">业务共享</span></span
        ></strong
      >
    </p>
    <p style="font-family: Calibri; font-size: 14px; white-space: normal">
      <strong
        ><span style="font-family: 微软雅黑; font-size: 14px"
          ><span style="font-family: 微软雅黑">（</span
          >1）为便于我们基于统一的账号体系向您提供服务以及便于您进行统一管理、保障系统和账号安全，您的个人信息可能会在我们和我们的关联公司之间进行必要共享。</span
        ></strong
      ><strong
        ><span style="font-family: 微软雅黑; font-size: 14px"
          ><span style="font-family: 微软雅黑"
            >但我们只会共享必要的个人信息，且受本政策中所声明目的的约束；我们的关联公司如要改变个人信息的处理目的，将再次征求您的授权同意。例如，为了我们的关联公司为向您提供服务而需履行监管对客户身份识别的要求，或为我们与关联公司共同向您提供或推荐服务、产品，或为了协助解决您与我们的关联公司之间就交易产生的纠纷，我们会与关联公司共享您的信息。</span
          ></span
        ></strong
      >
    </p>
    <p style="font-family: Calibri; font-size: 14px; white-space: normal">
      <span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑">（2）某些产品或服务可能由第三方提供或由我们与第三方联合提供（您可以在具体产品</span
        >/服务协议中查看第三方合作机构的名称），我们必须将您的</span><strong
        ><span style="font-family: 微软雅黑; font-size: 14px"
          ><span style="font-family: 微软雅黑">订单信息</span></span
        ></strong
      ><span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑">与</span></span
      ><strong
        ><span style="font-family: 微软雅黑; font-size: 14px"
          ><span style="font-family: 微软雅黑">交易有关的必要信息</span></span
        ></strong
      ><span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑"
          >与第三方机构共享来实现您向其购买商品或服务的需求，并促使其可以完成后续的售后服务。</span
        ></span
      >
    </p>
    <p style="font-family: Calibri; font-size: 14px; white-space: normal">
      <span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑">（</span
        >3）某些营销活动可能由我们与第三方联合举办（您可以在具体活动规则相关页面中查看第三方合作机构的名称），只有将您参与活动过程中产生的、为完成活动所必要的信息共享给第三方时，才能及时与您联系、发放奖品、提供服务，我们会依据法律法规或国家标准的要求，在活动规则页面或通过其他途径向您明确告知需要向第三方提供何种个人信息。</span
      >
    </p>
    <p style="font-family: Calibri; font-size: 14px; white-space: normal">
      <span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑">（</span
        >4）为了让您完成交易、实现交易目的，我们需要向您的交易相对方提供</span
      ><strong
        ><span style="font-family: 微软雅黑; font-size: 14px"
          ><span style="font-family: 微软雅黑">交易号</span></span
        ></strong
      ><span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑">与</span></span
      ><strong
        ><span style="font-family: 微软雅黑; font-size: 14px"
          ><span style="font-family: 微软雅黑">相关支付信息</span></span
        ></strong
      ><span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑"
          >，同时您的交易相对方可在付款过程中或付款成功后查看您的</span
        ></span
      ><strong
        ><span style="font-family: 微软雅黑; font-size: 14px"
          ><span style="font-family: 微软雅黑">部分注册信息</span></span
        ></strong
      ><span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑">。</span></span
      ><strong
        ><span style="font-family: 微软雅黑; font-size: 14px"
          >&nbsp;</span
        ></strong
      >
    </p>
    <p style="font-family: Calibri; font-size: 14px; white-space: normal">
      <span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑">（</span></span
      ><span style="font-family: 微软雅黑; font-size: 14px">5</span
      ><span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑">）</span></span
      ><span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑">广告、分析服务类的合作</span></span
      ><span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑">方</span></span
      ><span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑">。除非得到您的许可，</span></span
      ><span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑"
          >否则我们不会将您的个人身份信息（指可以识别您身份的信息，例如姓名）与提供广告、分析服务的合作伙伴分享。对于广告合作方，我们可能会向其提供有关广告覆盖面和有效性的信息，而不会提供您的个人身份信息，或者我们将这些信息进行去标识化或匿名化处理，以便它不会识别到您个人。这类合作伙伴可能将上述信息与他们合法获取的其他数据相结合，以执行我们委托的广告服务或决策建议。如果您想关闭程序化广告，您可以根据本政策第六部分第（五）节的描述关闭相关功能。</span
        ></span
      >
    </p>
    <p class="text">
      （6）提供技术服务的第三方SDK提供商。关于提供商的身份、收集个人信息的目的、方式、范围等情况，请您详细参见本政策<a
        href="https://h5.m.jd.com/babelDiy/Zeus/2gA11VaUdCYknGCS2x6cLLJf8USZ/index.html"
        >个人信息共享清单</a
      >。
    </p>
    <p style="font-family: Calibri; font-size: 14px; white-space: normal">
      <strong
        ><span style="font-family: 微软雅黑; font-size: 14px"
          >2、纠纷处理</span
        ></strong
      >
    </p>
    <p style="font-family: Calibri; font-size: 14px; white-space: normal">
      <span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑">为了保</span></span
      ><span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑">障</span></span
      ><span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑"
          >您及他人的合法权益，如您</span
        ></span
      ><span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑"
          >与其他用户、商家等第三方发生纠纷、投诉或被投诉时</span
        ></span
      ><span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑">，我们会将您的</span></span
      ><strong
        ><span style="font-family: 微软雅黑; font-size: 14px"
          ><span style="font-family: 微软雅黑"
            >姓名、有效证件号码、联系方式、投诉相关内容</span
          ></span
        ></strong
      ><span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑"
          >提供给消费者权益保护部门及监管机关，以便及时解决投诉纠纷，但法律法规明确禁止提供的除外。</span
        ></span
      >
    </p>
    <p
      style="
        margin: 0 0 8px;
        font-family: Calibri;
        font-size: 14px;
        white-space: normal;
      "
    >
      <strong
        ><span style="font-family: 微软雅黑; font-size: 14px">3、</span></strong
      ><strong
        ><span style="font-family: 微软雅黑; font-size: 14px"
          ><span style="font-family: 微软雅黑"
            >我们可能会根据法律法规规定，或按政府主管部门的强制性要求，对外共享您的个人信息。如果我们在此过程中违反法律法规的规定，给您造成损失的，我们将承担因此引起的相应责任。</span
          ></span
        ></strong
      >
    </p>
    <p style="font-family: Calibri; font-size: 14px; white-space: normal">
      <strong
        ><span style="font-family: 微软雅黑; font-size: 14px"
          ><span style="font-family: 微软雅黑">（三）转让</span></span
        ></strong
      >
    </p>
    <p style="font-family: Calibri; font-size: 14px; white-space: normal">
      <span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑"
          >我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：</span
        ></span
      >
    </p>
    <p style="font-family: Calibri; font-size: 14px; white-space: normal">
      <span style="font-family: 微软雅黑; font-size: 14px">1、</span
      ><span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑"
          >在获得您的明确同意后，我们会向其他方转让您的个人信息；</span
        ></span
      >
    </p>
    <p style="font-family: Calibri; font-size: 14px; white-space: normal">
      <span style="font-family: 微软雅黑; font-size: 14px">2、</span
      ><span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑"
          >根据适用的法律法规、法律程序的要求、强制性的行政或司法要求所必须的情况进行提供；</span
        ></span
      >
    </p>
    <p style="font-family: Calibri; font-size: 14px; white-space: normal">
      <span style="font-family: 微软雅黑; font-size: 14px">3</span
      ><span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑">、</span></span
      ><span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑">在涉及合并、收购或</span></span
      ><span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑">破产清算</span></span
      ><span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑"
          >时，如涉及到个人信息转让，我们</span
        ></span
      ><span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑">会在要</span></span
      ><span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑"
          >求新的持有您个人信息的公司、组织继续受本政策的约束，否则我们将要求该公司、组织重新向您征求授权同意</span
        ></span
      ><span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑">。</span></span
      >
    </p>
    <p style="font-family: Calibri; font-size: 14px; white-space: normal">
      <strong
        ><span style="font-family: 微软雅黑; font-size: 14px"
          ><span style="font-family: 微软雅黑">（四）公开披露</span></span
        ></strong
      >
    </p>
    <p style="font-family: Calibri; font-size: 14px; white-space: normal">
      <span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑"
          >除在公布中奖活动名单时会脱敏展示</span
        ></span
      ><strong
        ><span style="font-family: 微软雅黑; font-size: 14px"
          ><span style="font-family: 微软雅黑">中奖者手机号</span></span
        ></strong
      ><span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑">或</span></span
      ><strong
        ><span style="font-family: 微软雅黑; font-size: 14px"
          ><span style="font-family: 微软雅黑">京东账号名</span></span
        ></strong
      ><span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑"
          >外，我们仅会在以下情况下，才会公开披露您的个人信息：</span
        ></span
      >
    </p>
    <p style="font-family: Calibri; font-size: 14px; white-space: normal">
      <span style="font-family: 微软雅黑; font-size: 14px">1、</span
      ><span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑"
          >获得您的明确同意后，按您明确同意的披露方式披露您所指定的个人信息；</span
        ></span
      >
    </p>
    <p style="font-family: Calibri; font-size: 14px; white-space: normal">
      <span style="font-family: 微软雅黑; font-size: 14px">2、</span
      ><span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑"
          >在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会公开披露您的个人信息。在符合法律法规的前提下，当我们收到上述披露信息的请求时，我们会要求必须出具与之相应的法律文件，如传票或调查函。我们坚信，对于要求我们提供的信息，应该在法律允许的范围内尽可能保持透明。我们对所有的请求都进行了慎重的审查，以确保其具备合法依据，且仅限于执法部门因特定调查目的且有合法权利获取的数据。</span
        ></span
      >
    </p>
    <p style="font-family: Calibri; font-size: 14px; white-space: normal">
      <strong
        ><span style="font-family: 微软雅黑; font-size: 14px"
          ><span style="font-family: 微软雅黑"
            >（五）共享、转让、公开披露个人信息时事先征得授权同意的例外</span
          ></span
        ></strong
      >
    </p>
    <p style="font-family: Calibri; font-size: 14px; white-space: normal">
      <span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑"
          >根据相关法律法规及国家标准，以下情形中，我们共享、转让、公开披露您的个人信息不必事先征得您的授权同意：</span
        ></span
      >
    </p>
    <p style="font-family: Calibri; font-size: 14px; white-space: normal">
      <span style="font-family: 微软雅黑; font-size: 14px">1</span
      ><span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑"
          >、与您履行法律法规规定的义务相关的；</span
        ></span
      >
    </p>
    <p style="font-family: Calibri; font-size: 14px; white-space: normal">
      <span style="font-family: 微软雅黑; font-size: 14px">2</span
      ><span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑"
          >、与国家安全、国防安全直接相关的；</span
        ></span
      >
    </p>
    <p style="font-family: Calibri; font-size: 14px; white-space: normal">
      <span style="font-family: 微软雅黑; font-size: 14px"
        >3、与公共安全、公共卫生、重大公共利益直接相关的；</span
      >
    </p>
    <p style="font-family: Calibri; font-size: 14px; white-space: normal">
      <span style="font-family: 微软雅黑; font-size: 14px">4</span
      ><span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑"
          >、与刑事侦查、起诉、审判和判决执行等直接相关的；</span
        ></span
      >
    </p>
    <p style="font-family: Calibri; font-size: 14px; white-space: normal">
      <span style="font-family: 微软雅黑; font-size: 14px">5</span
      ><span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑"
          >、出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人授权同意的；</span
        ></span
      >
    </p>
    <p style="font-family: Calibri; font-size: 14px; white-space: normal">
      <span style="font-family: 微软雅黑; font-size: 14px">6</span
      ><span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑"
          >、您自行向社会公众公开的个人信息；</span
        ></span
      >
    </p>
    <p style="font-family: Calibri; font-size: 14px; white-space: normal">
      <span style="font-family: 微软雅黑; font-size: 14px">7</span
      ><span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑"
          >、从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。</span
        ></span
      >
    </p>
    <p style="font-family: Calibri; font-size: 14px; white-space: normal">
      <span style="font-family: 微软雅黑; font-size: 14px">&nbsp;</span>
    </p>
    <h1
      style="
        break-after: avoid;
        text-align: justify;
        font-family: 'Microsoft YaHei UI';
        font-size: 14px;
        white-space: normal;
      "
    >
      <strong
        ><span style="font-family: 微软雅黑; font-size: 14px"
          >五、我们如何保护您的个人信息</span
        ></strong
      >
    </h1>
    <p style="font-family: Calibri; font-size: 14px; white-space: normal">
      <strong
        ><span style="font-family: 微软雅黑; font-size: 14px"
          ><span style="font-family: 微软雅黑"
            >（一）我们保护您个人信息的技术与措施</span
          ></span
        ></strong
      >
    </p>
    <p style="font-family: Calibri; font-size: 14px; white-space: normal">
      <span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑"
          >我们非常重视个人信息安全，并采取一切合理可行的措施，保护您的个人信息：</span
        ></span
      ><em
        ><span
          style="font-family: 微软雅黑; color: rgb(255, 0, 0); font-size: 14px"
          >&nbsp;</span
        ></em
      >
    </p>
    <p style="font-family: Calibri; font-size: 14px; white-space: normal">
      <strong
        ><span style="font-family: 微软雅黑; font-size: 14px"
          >1、数据安全技术措施</span
        ></strong
      >
    </p>
    <p style="font-family: Calibri; font-size: 14px; white-space: normal">
      <span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑"
          >我们已采用符合业界标准的安全防护措施以及行业内通行的安全技术来防止您的个人信息遭到未经授权的访问、修改，避免您的个人信息泄露、损坏或丢失：</span
        ></span
      >
    </p>
    <p style="font-family: Calibri; font-size: 14px; white-space: normal">
      <span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑">（</span></span
      ><span style="font-family: 微软雅黑; font-size: 14px"
        >1）采取加密技术对您的个人信息进行加密存储</span
      ><span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑"
          >，我们存储您个人数据的系统已通过</span
        ></span
      ><span style="font-family: 微软雅黑; font-size: 14px">&nbsp;</span
      ><span style="font-family: 微软雅黑; font-size: 14px"
        >PCI DSS（第三方支付行业数据安全标准）</span
      ><span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑"
          >认证，从安全管理、策略、过程、网络体系结构等诸多方面保障交易及个人信息安全。</span
        ></span
      >
    </p>
    <p style="font-family: Calibri; font-size: 14px; white-space: normal">
      <span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑">（</span></span
      ><span style="font-family: 微软雅黑; font-size: 14px"
        >2）我们的网络服务采取了传输</span
      ><span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑"
          >层安全协议等加密技术，通过</span
        ></span
      ><span style="font-family: 微软雅黑; font-size: 14px"
        >https等方式提供浏览服务，确保您的个人信息在传输过程中的安全。</span
      >
    </p>
    <p style="font-family: Calibri; font-size: 14px; white-space: normal">
      <span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑">（</span></span
      ><span style="font-family: 微软雅黑; font-size: 14px">3</span
      ><span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑"
          >）在使用您的个人信息时，例如个人信息展示、个人信息关联计算，我们会采用包括内容替换、</span
        ></span
      ><span style="font-family: 微软雅黑; font-size: 14px"
        >SHA256在内的多种数据脱敏技术增强个人信息在使用中的安全性。</span
      >
    </p>
    <p style="font-family: Calibri; font-size: 14px; white-space: normal">
      <span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑">（</span></span
      ><span style="font-family: 微软雅黑; font-size: 14px">4</span
      ><span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑"
          >）我们会采用白盒代码安全检测、黑盒安全测试、入侵检测防御技术进行恶意代码防范措施保护您的个人信息安全。</span
        ></span
      >
    </p>
    <p style="font-family: Calibri; font-size: 14px; white-space: normal">
      <strong
        ><span style="font-family: 微软雅黑; font-size: 14px"
          >2、为保护个人信息采取的其他安全措施</span
        ></strong
      >
    </p>
    <p style="font-family: Calibri; font-size: 14px; white-space: normal">
      <span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑"
          >我们通过建立数据分类分级、数据安全管理规范、安全开发规范来管理规范个人信息的存储和使用：</span
        ></span
      >
    </p>
    <p style="font-family: Calibri; font-size: 14px; white-space: normal">
      <span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑">（</span></span
      ><span style="font-family: 微软雅黑; font-size: 14px"
        >1）我们采用严格的数据访问权限和多重身份认证技术控制和保护个人信息，通过与信息接触</span
      ><span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑"
          >者签署严格的保密协议、监控和审计机制来对数据进行全面安全控制，避免数据被违规使用。</span
        ></span
      >
    </p>
    <p style="font-family: Calibri; font-size: 14px; white-space: normal">
      <span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑">（</span></span
      ><span style="font-family: 微软雅黑; font-size: 14px"
        >2）我们采用代码安全检查、数据访问日志分析技术进行个人信息安全审计。</span
      >
    </p>
    <p style="font-family: Calibri; font-size: 14px; white-space: normal">
      <span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑">（</span></span
      ><span style="font-family: 微软雅黑; font-size: 14px"
        >3）我们建立了信息安全委员会并下设信息安全小组，由各小组信息安全专员负责个人信息安全事务。</span
      >
    </p>
    <p style="font-family: Calibri; font-size: 14px; white-space: normal">
      <span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑">（</span></span
      ><span style="font-family: 微软雅黑; font-size: 14px"
        >4）我们还会举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。</span
      >
    </p>
    <p style="font-family: Calibri; font-size: 14px; white-space: normal">
      <strong
        ><span style="font-family: 微软雅黑; font-size: 14px"
          >3、安全事件处置</span
        ></strong
      >
    </p>
    <p style="font-family: Calibri; font-size: 14px; white-space: normal">
      <span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑">（</span></span
      ><span style="font-family: 微软雅黑; font-size: 14px">1）</span
      ><span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑"
          >互联网环境并非百分之百安全，我们将尽力确保或担保您发送给我们的任何信息的安全性。如果我们的物理、技术、或管理防护设施遭到破坏，导致信息被非授权访问、公开披露、篡改、或毁坏，导致您的合法权益受损，我们将承担相应的法律责任。</span
        ></span
      >
    </p>
    <p style="font-family: Calibri; font-size: 14px; white-space: normal">
      <span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑">（</span>2）</span
      ><span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑"
          >为应对个人信息泄露、损毁和丢失等可能出现的风险，我们制定了多项制度，明确安全事件、安全漏洞的分类分级标准及相应的处理流程。我们为安全事件建立了专门的应急响应团队，按照安全事件处置规范要求，针对不同安全事件启动安全预案，进行止损、分析、定位、制定补救措施、联合相关部门进行溯源和打击。</span
        ></span
      >
    </p>
    <p style="font-family: Calibri; font-size: 14px; white-space: normal">
      <span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑">（</span></span
      ><span style="font-family: 微软雅黑; font-size: 14px"
        >3）一旦发生个人信息安全事件，我们将按照法律法规的要求，及时向您告知安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们同时将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。</span
      >
    </p>
    <p style="font-family: Calibri; font-size: 14px; white-space: normal">
      <span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑">（</span></span
      ><span style="font-family: 微软雅黑; font-size: 14px">4）</span
      ><strong
        ><span style="font-family: 微软雅黑; font-size: 14px"
          ><span style="font-family: 微软雅黑"
            >如您发现自己的个人信息泄密，尤其是您的账号及密码发生泄露，请您立即通过本政策最下方</span
          ></span
        ></strong
      ><a href="#十、如何联系我们"
        ><strong
          ><span style="text-decoration: underline"
            ><span
              style="
                font-family: 微软雅黑;
                color: rgb(0, 0, 255);
                font-size: 14px;
              "
              ><span style="font-family: 微软雅黑">【如何联系我们】</span></span
            ></span
          ></strong
        ></a
      ><strong
        ><span style="font-family: 微软雅黑; font-size: 14px"
          ><span style="font-family: 微软雅黑"
            >约定的联系方式联络我们，以便我们采取相应措施。</span
          ></span
        ></strong
      >
    </p>
    <p style="font-family: Calibri; font-size: 14px; white-space: normal">
      <strong
        ><span style="font-family: 微软雅黑; font-size: 14px"
          ><span style="font-family: 微软雅黑"
            >（二）我们如何存储和保存您的个人信息</span
          ></span
        ></strong
      >
    </p>
    <p style="font-family: Calibri; font-size: 14px; white-space: normal">
      <span style="font-family: 微软雅黑; font-size: 14px">1、</span
      ><span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑"
          >我们仅在本政策所述目的所必需期间和法律法规及监管规定的时限内保存您的个人信息。我们承诺为了保证您的消费者权益，除非法律法规另有规定，您的</span
        ></span
      ><strong
        ><span style="font-family: 微软雅黑; font-size: 14px"
          ><span style="font-family: 微软雅黑"
            >个人信息我们将保存至您账号注销之日后的一个月</span
          ></span
        ></strong
      ><span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑"
          >。当您的个人信息超出我们所保存的期限后，我们会对您的个人信息进行删除或匿名化处理。</span
        ></span
      >
    </p>
    <p style="font-family: Calibri; font-size: 14px; white-space: normal">
      <span style="font-family: 微软雅黑; font-size: 14px">2</span
      ><span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑"
          >、在您终止使用我们的服务后，我们会停止对您的信息的收集和使用，法律法规或监管部门另有规定的除外。</span
        ></span
      ><span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑"
          >如果我们终止服务或运营，我们将及时停止收集您个人信息的活动，至少提前三十天通知您，并在终止服务或运营后对您的个人信息进行删除或匿名化处理。</span
        ></span
      >
    </p>
    <p>&nbsp;</p>
    <p class="text strong">六、您的权利</p>
    <p class="text">
      京东金融非常重视您对个人信息的关注，按照中国相关的法律、法规、标准的通行做法，尽全力保障您对自己的个人信息行使以下权利：
    </p>
    <p class="text strong">（一）访问您的个人信息</p>
    <p class="text">
      1、您有权随时访问您的个人信息，法律法规规定的例外情况除外。如果您想行使数据访问权，可以通过以下方式自行访问：
    </p>
    <p class="text">（1）您的账号信息</p>
    <p class="text">移动端APP内操作路径：</p>
    <p class="text">
      账号信息、身份信息、绑定手机号码：首页－我的－个人信息（左上角头像）-访问头像、昵称、京东账号名、实名认证信息（姓名、性别、国家/地区、证件类型、证件号码、证件有效期、职业、地址）、绑定手机号码。如果您需要解除绑定银行卡，您可通过“首页－我的－我的银行卡-设置-解除绑定”进行操作。
    </p>
    <p class="text">
      账号密码、安全信息：首页－我的-设置（右上角图标）－安全中心－修改登录密码、修改支付密码；
    </p>
    <p class="text">银行卡：首页－我的－我的银行卡。</p>
    <p class="text">电脑网页端操作路径：</p>
    <p class="text">
      您可以点击网页顶部您个人账号名称，进入“我的京东”，进行账号相关的操作。
    </p>
    <p class="text">
      您也可以点击网页顶部最右侧“网站导航”，选择“安全中心”，在“我的账户”、“我的银行卡”内进行操作。
    </p>
    <p class="text">（2）您的交易信息</p>
    <p class="text">移动端APP内操作路径：</p>
    <p class="text">
      首页－我的－总资产、总待还、我的保险、我的账单等历史交易信息。
    </p>
    <p class="text">
      电脑网页端操作路径：点击右侧头像资产总览、我的保险等历史交易信息。
    </p>
    <p class="text">（3）您的搜索记录</p>
    <p class="text">
      您可以点击搜索栏访问或清除您的搜索记录，进入“首页－我的－我的收藏、我的关注”查看和修改兴趣以及管理其他数据。
    </p>
    <p class="text">
      2、如果您无法通过上述链接访问这些个人信息，您可以随时通过本政策<a
        href="#十、如何联系我们"
        >【如何联系我们】</a
      >约定的联系方式联络我们。我们将在15个工作日内回复您的访问请求并完成核查与处理。
    </p>
    <p class="text">
      3、对于您在使用我们的产品或服务过程中产生的其他个人信息，只要我们不需要过多投入，我们会向您提供。如果您想行使数据访问权，您可以通过设置-隐私设置-个人信息与权限-个人信息浏览与导出功能查看，或通过本政策<a
        href="#十、如何联系我们"
        >【如何联系我们】</a
      >约定的联系方式联络我们。
    </p>
    <p class="text strong">（二）更正您的个人信息</p>
    <p class="text">
      当您发现我们处理的关于您的个人信息有错误时，您有权要求我们作出更正。您可以通过“（一）访问您的个人信息”中罗列的方式提出更正申请。
    </p>
    <p class="text">
      如果您无法通过上述链接更正这些个人信息，您可以随时通过本政策<a
        href="#十、如何联系我们"
        >【如何联系我们】</a
      >约定的联系方式联络我们。
    </p>
    <p class="text">我们将在15个工作日内回复您的更正请求并完成核查与处理。</p>
    <p class="text strong">（三）删除您的个人信息</p>
    <p class="text">
      1、在以下情形中，您可以通过拨打客服电话95118向我们提出删除个人信息的请求：
    </p>
    <p class="text">（1）如果我们处理个人信息的行为违反法律法规；</p>
    <p class="text">（2）如果我们收集、使用您的个人信息，却未征得您的同意；</p>
    <p class="text">（3）如果我们处理个人信息的行为违反了与您的约定；</p>
    <p class="text">
      收到您的删除请求后，我们会根据您及相关法律法规的要求进行后续删除处理并向您反馈结果。若我们决定响应您的删除请求，我们还将同时通知从我们获得您的个人信息的实体，要求其及时删除，除非法律法规另有规定，或这些实体获得您的独立授权。
    </p>
    <p class="text">
      2、当您从我们的服务中删除信息后，我们可能不会立即在备份系统中删除相应的信息，但会在备份更新时删除这些信息。
    </p>
    <p class="text strong">（四）注销您的账户</p>
    <p class="text">
      您可以在我们的产品与/或服务中直接申请注销账号、注销京东金融服务或注销您申请的具体服务功能，您可以通过移动端APP访问<span
        class="strong"
        >“我的-设置（右上角图标）-安全中心-更多服务-账户注销”</span
      >完成账户注销，还可以通过本政策<a href="#十、如何联系我们"
        >【如何联系我们】</a
      >约定的联系方式与我们联系，经核实您的注销信息、您的合同履行情况等具体细节后，我们对您的注销账号申请进行处理。
    </p>
    <p class="text strong">（五）改变您授权同意的范围</p>
    <p class="text">
      1、您可以通过京东金融APP“<span class="strong"
        >我的-设置-隐私设置-程序化广告设置</span
      >”开启或关闭程序化广告推送。
    </p>
    <p class="text">
      2、您可以通过京东金融APP“<span class="strong"
        >我的-设置-隐私设置-个性化推荐设置</span
      >”开启或关闭个性化推荐。
    </p>
    <p class="text">
      3、如果您不希望接收我们给您发送的营销信息，您随时可以通过以下方式取消：
    </p>
    <p class="text">
      （1）您可以在移动端APP“<span class="strong"
        >我的-设置（右上角图标）－通知设置</span
      >”中取消营销站内信、营销PUSH通知。
    </p>
    <p class="text">
      （2）您可以回复“<span class="strong">N</span>”或“<span class="strong"
        >BP</span
      >”或“<span class="strong">BR</span
      >”（具体以短信内容中提示为准）来取消我们给您发送的营销短信。
    </p>
    <p class="text">
      （3）您还可以随时通过访问https://jrhelp.jd.com<span class="strong"
        >在线客服系统</span
      >、或拨打我们的<span class="strong">客服电话</span
      >要求取消营销站内信、营销PUSH通知、营销短信、营销电话。
    </p>
    <p class="text">
      4、如果您希望关闭您之前已开启的设备敏感权限，您可以在设备系统设置或京东金融APP“<span
        class="strong"
        >我的-设置（右上角图标）-隐私设置-个人信息与权限-授权管理</span
      >”进行自主设置。
    </p>
    <p class="text">
      5、您也可以通过注销具体产品、注销京东金融服务、注销京东账号的方式，撤回我们继续收集您个人信息的全部授权。
    </p>
    <p class="text strong">
      请您理解，每个业务功能需要一些基本的个人信息才能得以完成（见本政策“<a
        href="#_一、我们如何收集和使用您的个人信息"
        >第一部分</a
      >”），当您撤回同意或授权后，我们无法继续为您提供撤回同意或授权所对应的服务，也不再处理您相应的个人信息。但您撤回同意或授权的决定，不会影响此前基于您的授权而开展的个人信息处理。
    </p>
    <p class="text strong">（六）获取您的个人信息副本</p>
    <p class="text">
      您有权获取您的个人信息副本。如您需要获取我们收集的您的个人信息副本，您可通过拨打客服热线95118，人工客服会对您进行身份核验后，将个人信息副本提交给您。在符合相关法律规定且技术可行的前提下，我们将根据您的要求向您提供您的个人信息副本。
    </p>
    <p class="text strong">（七）约束信息系统自动决策</p>
    <p class="text">
      在某些业务功能中，我们可能仅依据信息系统、算法等在内的非人工自动决策机制作出决定。如果这些决定显著影响您的合法权益，您有权要求我们作出解释，我们也将提供适当的救济方式。
    </p>
    <p class="text strong">（八）响应您的上述请求</p>
    <p class="text">
      为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。
    </p>
    <p class="text">
      我们将在十五个工作日内作出答复并完成核查与处理。如您不满意，还可以拨打电话95118进行投诉。
    </p>
    <p class="text">
      对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情况收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际（例如，涉及备份磁带上存放的信息）的请求，我们可能会予以拒绝。
    </p>
    <p class="text">在以下情形中，我们将无法响应您的请求：</p>
    <p class="text">（1）与个人信息控制者履行法律法规规定的义务相关的；</p>
    <p class="text">（2）与国家安全、国防安全有关的；</p>
    <p class="text">（3）与公共安全、公共卫生、重大公共利益直接有关的；</p>
    <p class="text">（4）与刑事侦查、起诉、审判和执行判决等直接有关的；</p>
    <p class="text">
      （5）有充分证据表明个人信息主体存在主观恶意或滥用权利的；
    </p>
    <p class="text">
      （6）出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；
    </p>
    <p class="text">
      （7）响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；
    </p>
    <p class="text">（8）涉及商业秘密的。</p>
    <p style="font-family: Calibri; font-size: 14px; white-space: normal">
      <span style="font-family: 微软雅黑; font-size: 14px">&nbsp;</span>
    </p>
    <h1
      style="
        break-after: avoid;
        text-align: justify;
        font-family: 'Microsoft YaHei UI';
        font-size: 14px;
        white-space: normal;
      "
    >
      <strong
        ><span style="font-family: 微软雅黑; font-size: 14px"
          >七、我们如何处理儿童的</span
        ></strong
      ><strong
        ><span style="font-family: 微软雅黑; font-size: 14px"
          >个人信息</span
        ></strong
      >
    </h1>
    <p style="font-family: Calibri; font-size: 14px; white-space: normal">
      <span style="font-family: 微软雅黑; font-size: 14px">1、</span
      ><span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑">我们的产品、网站和</span></span
      ><span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑">服务主要面向成人。</span></span
      ><span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑">若您是</span></span
      ><span style="font-family: 微软雅黑; font-size: 14px">14周</span
      ><span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑"
          >岁以下的儿童，在使用我们的产品与</span
        ></span
      ><span style="font-family: 微软雅黑; font-size: 14px">/</span
      ><span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑"
          >或服务或向我们提供您的个人信息前，</span
        ></span
      ><strong
        ><span style="font-family: 微软雅黑; font-size: 14px"
          ><span style="font-family: 微软雅黑"
            >应事先取得您家长或法定</span
          ></span
        ></strong
      ><strong
        ><span style="font-family: 微软雅黑; font-size: 14px"
          ><span style="font-family: 微软雅黑">监护人的同意</span></span
        ></strong
      ><span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑">。</span></span
      >
    </p>
    <p style="font-family: Calibri; font-size: 14px; white-space: normal">
      <span style="font-family: 微软雅黑; font-size: 14px">2</span
      ><span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑">、</span></span
      ><span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑"
          >对于经父母或其他监护人同意而收集儿童个人信息的情况，我们只会在受到法律允许、父母或其他监护人明确同意或者保护儿童所必要的情况下使用或公开披露此信息。</span
        ></span
      >
    </p>
    <p style="font-family: Calibri; font-size: 14px; white-space: normal">
      <span style="font-family: 微软雅黑; font-size: 14px">3、</span
      ><span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑"
          >尽管当地法律和习俗对儿童的定义不同，但我们将不满</span
        ></span
      ><span style="font-family: 微软雅黑; font-size: 14px">14周岁</span
      ><span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑">的任何人视为儿童。</span></span
      >
    </p>
    <p style="font-family: Calibri; font-size: 14px; white-space: normal">
      <span style="font-family: 微软雅黑; font-size: 14px"
        >4、如果我们发现自己在未事先获得可证实的父母或其他监护人同意的情况下收集了儿童的个人信息，或儿童的父母或其他监护人撤回其同意的，则会设法尽快删除相关数据。</span
      >
    </p>
    <p style="font-family: Calibri; font-size: 14px; white-space: normal">
      <span style="font-family: 微软雅黑; font-size: 14px"
        >5、更多详情，敬请查阅</span
      ><a
        href="https://h5.m.jd.com/babelDiy/Zeus/zSyKCvgyP8fQnaKot8tzscJXWFt/index.html"
        ><span style="text-decoration: underline"
          ><span
            style="
              font-family: 微软雅黑;
              color: rgb(0, 0, 255);
              font-size: 14px;
            "
            ><span style="font-family: 微软雅黑"
              >《京东金融儿童隐私保护规则及监护人须知》</span
            ></span
          ></span
        ></a
      ><span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑">。</span></span
      >
    </p>
    <p style="font-family: Calibri; font-size: 14px; white-space: normal">
      <span style="font-family: 微软雅黑; font-size: 14px">&nbsp;</span>
    </p>
    <h1
      style="
        break-after: avoid;
        text-align: justify;
        font-family: 'Microsoft YaHei UI';
        font-size: 14px;
        white-space: normal;
      "
    >
      <strong
        ><span style="font-family: 微软雅黑; font-size: 14px"
          >八、您的个人信息如何在全球范围转移</span
        ></strong
      >
    </h1>
    <p style="font-family: Calibri; font-size: 14px; white-space: normal">
      <span style="font-family: 微软雅黑; font-size: 14px">1</span
      ><span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑">、</span></span
      ><span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑"
          >我们在中华人民共和国境内收集和产生的个人信息，将存储在中华人民共和国境内，以下情形除外：</span
        ></span
      >
    </p>
    <p style="font-family: Calibri; font-size: 14px; white-space: normal">
      <span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑">（</span
        >1）适用的法律有明确规定；</span
      >
    </p>
    <p style="font-family: Calibri; font-size: 14px; white-space: normal">
      <span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑">（</span
        >2）获得您的明确授权；</span
      >
    </p>
    <p style="font-family: Calibri; font-size: 14px; white-space: normal">
      <span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑">（</span
        >3）您通过互联网进行跨境交易行为。</span
      >
    </p>
    <p style="font-family: Calibri; font-size: 14px; white-space: normal">
      <span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑"
          >针对以上情形，我们会确保依据本政策对您的个人信息提供足够的保护。</span
        ></span
      >
    </p>
    <p style="font-family: Calibri; font-size: 14px; white-space: normal">
      <span style="font-family: 微软雅黑; font-size: 14px"
        >2、如您使用跨境业务，且需要向境外传输您的个人信息完成交易的，我们会按照法律法规和相关监管部门的规定执行，对个人信息出境目的、个人信息类型、接收方、安全保障措施等进行说明，并要求接收方按照法律法规和相关监管部门的规定并采取相关保密和安全措施来处理这些个人信息。这意味着，在获得您的授权同意后，您的个人信息可能会被转移到您使用产品或服务所在国家/地区的境外管辖区，或者受到来自这些管辖区的访问。此类管辖区可能设有不同的数据保护法，甚至未设立相关法律。在此类情况下，我们会确保您的个人信息得到在中华人民共和国境内足够同等的保护。例如，我们会请求您对跨境转移个人信息的同意，或者在跨境数据转移之前实施数据去标识化等安全举措。</span
      >
    </p>
    <p style="font-family: Calibri; font-size: 14px; white-space: normal">
      <span style="font-family: 微软雅黑; font-size: 14px"
        >3、目前我们在中国境内收集的个人信息存储、处理和分析在中国境内进行，对跨境数据传输有严格的审查流程。</span
      >
    </p>
    <p style="font-family: Calibri; font-size: 14px; white-space: normal">
      <span style="font-family: 微软雅黑; font-size: 14px">&nbsp;</span>
    </p>
    <h1
      style="
        break-after: avoid;
        text-align: justify;
        font-family: 'Microsoft YaHei UI';
        font-size: 14px;
        white-space: normal;
      "
    >
      <strong
        ><span style="font-family: 微软雅黑; font-size: 14px"
          >九、本政策如何更新</span
        ></strong
      >
    </h1>
    <p style="font-family: Calibri; font-size: 14px; white-space: normal">
      <span style="font-family: 微软雅黑; font-size: 14px">1、</span
      ><span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑"
          >我们的隐私政策可能变更。</span
        ></span
      ><span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑"
          >未经您明确同意，我们不会削减您依据本政策所应享有的权利。我们会在京东金融官方网站上发布对本政策所做的任何变更。</span
        ></span
      >
    </p>
    <p style="font-family: Calibri; font-size: 14px; white-space: normal">
      <span style="font-family: 微软雅黑; font-size: 14px">2、</span
      ><span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑"
          >对于重大变更，我们还会采取如下任一方式及时通知您：</span
        ></span
      >
    </p>
    <p style="font-family: Calibri; font-size: 14px; white-space: normal">
      <span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑">（</span
        >1）您登录相关客户端软件或使用京东金融服务时进行弹窗提醒；</span
      >
    </p>
    <p style="font-family: Calibri; font-size: 14px; white-space: normal">
      <span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑">（</span
        >2）您更新客户端软件版本时进行弹窗提醒；</span
      >
    </p>
    <p style="font-family: Calibri; font-size: 14px; white-space: normal">
      <span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑">（</span
        >3）您使用京东金融服务时向您推送短消息通知；</span
      >
    </p>
    <p style="font-family: Calibri; font-size: 14px; white-space: normal">
      <span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑">（</span
        >4）在京东金融官方网站进行公告。</span
      >
    </p>
    <p style="font-family: Calibri; font-size: 14px; white-space: normal">
      <span style="font-family: 微软雅黑; font-size: 14px"
        >3、本政策所指的重大变更包括但不限于：</span
      >
    </p>
    <p style="font-family: Calibri; font-size: 14px; white-space: normal">
      <span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑">（</span></span
      ><span style="font-family: 微软雅黑; font-size: 14px">1）我们</span
      ><span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑"
          >的业务和服务模式发生重大变化。如业务功能、处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；</span
        ></span
      >
    </p>
    <p style="font-family: Calibri; font-size: 14px; white-space: normal">
      <span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑">（</span></span
      ><span style="font-family: 微软雅黑; font-size: 14px"
        >2）我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；</span
      >
    </p>
    <p style="font-family: Calibri; font-size: 14px; white-space: normal">
      <span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑">（</span></span
      ><span style="font-family: 微软雅黑; font-size: 14px"
        >3）个人信息共享、转让或公开披露的主要对象发生变化；</span
      >
    </p>
    <p style="font-family: Calibri; font-size: 14px; white-space: normal">
      <span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑">（</span></span
      ><span style="font-family: 微软雅黑; font-size: 14px"
        >4）您参与个人信息处理方面的权利及其行使方式发生重大变化；</span
      >
    </p>
    <p style="font-family: Calibri; font-size: 14px; white-space: normal">
      <span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑">（</span></span
      ><span style="font-family: 微软雅黑; font-size: 14px"
        >5）我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；</span
      >
    </p>
    <p style="font-family: Calibri; font-size: 14px; white-space: normal">
      <span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑">（</span></span
      ><span style="font-family: 微软雅黑; font-size: 14px"
        >6）个人信息安全影响评估报告表明存在高风险时。</span
      >
    </p>
    <p style="font-family: Calibri; font-size: 14px; white-space: normal">
      <span style="font-family: 微软雅黑; font-size: 14px"
        >4、为了您能及时接收到通知，建议您在联系方式更新时及时通知我们。如您在本政策更新生效后继续使用我们的服务，即代表您已充分阅读、理解并接受更新后的政策并愿意受更新后的政策约束。我们鼓励您在每次使用我们服务时都查阅本政策。您可以在京东金融APP通过“首页-我的-设置-隐私设置-京东金融隐私政策”中查看本政策。</span
      >
    </p>
    <p style="font-family: Calibri; font-size: 14px; white-space: normal">
      <span style="font-family: 微软雅黑; font-size: 14px">&nbsp;</span>
    </p>
    <h1
      style="
        break-after: avoid;
        text-align: justify;
        font-family: 'Microsoft YaHei UI';
        font-size: 14px;
        white-space: normal;
      "
    >
      <a id="十、如何联系我们"> </a
      ><strong
        ><span style="font-family: 微软雅黑; font-size: 14px"
          >十、如何联系我们</span
        ></strong
      >
    </h1>
    <p style="font-family: Calibri; font-size: 14px; white-space: normal">
      <span style="font-family: 微软雅黑; font-size: 14px">1、</span
      ><span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑"
          >我们设立了个人信息保护专职部门和个人信息保护专员，如您对本政策或您个人信息的相关事宜有任何疑问、意见或建议，请通过以下方式与我们联系：</span
        ></span
      >
    </p>
    <p style="font-family: Calibri; font-size: 14px; white-space: normal">
      <span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑">（</span>1）拨打客服电话9</span
      ><span style="font-family: 微软雅黑; font-size: 14px">5118</span
      ><span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑">。</span></span
      >
    </p>
    <p style="font-family: Calibri; font-size: 14px; white-space: normal">
      <span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑">（</span></span
      ><span style="font-family: 微软雅黑; font-size: 14px">2</span
      ><span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑">）发送邮件至</span></span
      ><span style="font-family: 微软雅黑; font-size: 14px"
        >finance-cs@jd.com</span
      ><span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑">。</span></span
      >
    </p>
    <p style="font-family: Calibri; font-size: 14px; white-space: normal">
      <span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑">（</span>3）进入京东金融</span
      ><span style="font-family: 微软雅黑; font-size: 14px"
        >APP内点击“首页-我的-设置（右上角图标）-意见反馈”</span
      ><span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑">。</span></span
      >
    </p>
    <p style="font-family: Calibri; font-size: 14px; white-space: normal">
      <span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑">（</span>4）</span
      ><span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑">进入京东金融</span
        >APP内点击“首页-我的-我的客服”</span
      ><span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑">。</span></span
      >
    </p>
    <p style="font-family: Calibri; font-size: 14px; white-space: normal">
      <span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑">（</span></span
      ><span style="font-family: 微软雅黑; font-size: 14px">5</span
      ><span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑">）访问</span></span
      ><a href="https://jrhelp.jd.com/"
        ><span style="text-decoration: underline"
          ><span
            style="
              font-family: 微软雅黑;
              color: rgb(0, 0, 255);
              font-size: 14px;
            "
            >jrhelp.jd.com</span
          ></span
        ></a
      ><span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑">在线客服系统。</span></span
      >
    </p>
    <p style="font-family: Calibri; font-size: 14px; white-space: normal">
      <span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑"
          >客服部门将会同个人信息保护专职部门及时答复您。</span
        ></span
      >
    </p>
    <p style="font-family: Calibri; font-size: 14px; white-space: normal">
      <span style="font-family: 微软雅黑; font-size: 14px">2、</span
      ><span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑"
          >一般情况下，我们将在十五个工作日内回复并完成核查与处理。如果您对我们的回复不满意，特别是我们的个人信息处理行为损害了您的合法权益，您还可以通过以下外部途径寻求解决方案：向有管辖权的法院提起诉讼，或向网信、电信、公安及工商等监管部门进行投诉或举报。</span
        ></span
      >
    </p>
    <p style="font-family: Calibri; font-size: 14px; white-space: normal">
      <span style="font-family: 微软雅黑; font-size: 14px">&nbsp;</span>
    </p>
    <h1
      style="
        break-after: avoid;
        text-align: justify;
        font-family: 'Microsoft YaHei UI';
        font-size: 14px;
        white-space: normal;
      "
    >
      <a id="_十一、本政策中关键词定义"></a
      ><strong
        ><span style="font-family: 微软雅黑; font-size: 14px"
          >十一、本政策中关键词定义</span
        ></strong
      >
    </h1>
    <p class="text">
      1、“京东金融关联公司”：指京东科技控股股份有限公司直接或间接控制的公司、直接或间接控制京东科技控股股份有限公司的公司、或与京东科技控股股份有限公司共同受同一主体直接或间接控制或者施加重大影响的公司，例如：北京京东叁佰陆拾度电子商务有限公司、网银在线（北京）科技有限公司、北京肯特瑞基金销售有限公司、天津津投保险经纪有限公司、京东数科保险代理有限公司、上海京汇小额贷款有限公司、北京京汇小额贷款有限公司、重庆京东盛际小额贷款有限公司、重庆京东同盈小额贷款有限公司、上海东家铂睿资产管理有限公司、上海金顺东投资管理有限公司等。“关联”指一方现在或将来控制、受控制或与其处于共同控制下的任何公司、机构。“控制”是指直接或间接地拥有影响所提及公司管理的能力，无论是通过所有权、有投票权的股份、合同或其他被人民法院认定的方式。
    </p>
    <p class="text">
      2、“个人信息”：指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。本定义出自于GB/T
      35273-2020《信息安全技术
      个人信息安全规范》，以下为个人信息示例（非京东金融APP或网站所收集的个人信息，仅作示例说明）：
    </p>
    <table width="100%">
      <tbody>
        <tr class="firstRow">
          <td
            width="553"
            valign="top"
            colspan="2"
            style="
              padding: 0px 7px;
              border-width: 1px;
              border-color: windowtext;
            "
          >
            <p
              style="text-align: center; font-family: Calibri; font-size: 14px"
            >
              <strong
                ><span style="font-family: 微软雅黑; font-size: 14px"
                  >个人信息举例</span
                ></strong
              >
            </p>
          </td>
        </tr>
        <tr>
          <td
            width="123"
            valign="center"
            style="
              padding: 0px 7px;
              border-left-width: 1px;
              border-left-color: windowtext;
              border-right-width: 1px;
              border-right-color: windowtext;
              border-top: none;
              border-bottom-width: 1px;
              border-bottom-color: windowtext;
            "
          >
            <p style="font-family: Calibri; font-size: 14px">
              <span style="font-family: 微软雅黑; font-size: 14px"
                >个人基本信息</span
              >
            </p>
          </td>
          <td
            width="431"
            valign="center"
            style="
              padding: 0px 7px;
              border-left: none;
              border-right-width: 1px;
              border-right-color: windowtext;
              border-top-width: 1px;
              border-top-color: windowtext;
              border-bottom-width: 1px;
              border-bottom-color: windowtext;
            "
          >
            <p style="font-family: Calibri; font-size: 14px">
              <span style="font-family: 微软雅黑; font-size: 14px"
                >个人姓名、生日、性别、民族、国籍、家庭关系、地址、个人电话号码、电子邮箱等</span
              >
            </p>
          </td>
        </tr>
        <tr>
          <td
            width="123"
            valign="center"
            style="
              padding: 0px 7px;
              border-left-width: 1px;
              border-left-color: windowtext;
              border-right-width: 1px;
              border-right-color: windowtext;
              border-top: none;
              border-bottom-width: 1px;
              border-bottom-color: windowtext;
            "
          >
            <p style="font-family: Calibri; font-size: 14px">
              <span style="font-family: 微软雅黑; font-size: 14px"
                >个人身份信息</span
              >
            </p>
          </td>
          <td
            width="431"
            valign="center"
            style="
              padding: 0px 7px;
              border-left: none;
              border-right-width: 1px;
              border-right-color: windowtext;
              border-top: none;
              border-bottom-width: 1px;
              border-bottom-color: windowtext;
            "
          >
            <p style="font-family: Calibri; font-size: 14px">
              <span style="font-family: 微软雅黑; font-size: 14px"
                >身份证、军官证、护照、驾驶证、工作证、出入证、社保卡、居住证等</span
              >
            </p>
          </td>
        </tr>
        <tr>
          <td
            width="123"
            valign="center"
            style="
              padding: 0px 7px;
              border-left-width: 1px;
              border-left-color: windowtext;
              border-right-width: 1px;
              border-right-color: windowtext;
              border-top: none;
              border-bottom-width: 1px;
              border-bottom-color: windowtext;
            "
          >
            <p style="font-family: Calibri; font-size: 14px">
              <span style="font-family: 微软雅黑; font-size: 14px"
                >个人生物识别信息</span
              >
            </p>
          </td>
          <td
            width="431"
            valign="center"
            style="
              padding: 0px 7px;
              border-left: none;
              border-right-width: 1px;
              border-right-color: windowtext;
              border-top: none;
              border-bottom-width: 1px;
              border-bottom-color: windowtext;
            "
          >
            <p style="font-family: Calibri; font-size: 14px">
              <span style="font-family: 微软雅黑; font-size: 14px"
                >个人基因、指纹、声纹、掌纹、耳廓、虹膜、面部识别特征等</span
              >
            </p>
          </td>
        </tr>
        <tr>
          <td
            width="123"
            valign="center"
            style="
              padding: 0px 7px;
              border-left-width: 1px;
              border-left-color: windowtext;
              border-right-width: 1px;
              border-right-color: windowtext;
              border-top: none;
              border-bottom-width: 1px;
              border-bottom-color: windowtext;
            "
          >
            <p style="font-family: Calibri; font-size: 14px">
              <span style="font-family: 微软雅黑; font-size: 14px"
                >网络身份标识信息</span
              >
            </p>
          </td>
          <td
            width="431"
            valign="center"
            style="
              padding: 0px 7px;
              border-left: none;
              border-right-width: 1px;
              border-right-color: windowtext;
              border-top: none;
              border-bottom-width: 1px;
              border-bottom-color: windowtext;
            "
          >
            <p style="font-family: Calibri; font-size: 14px">
              <span style="font-family: 微软雅黑; font-size: 14px"
                >个人信息主体账号、 IP 地址、个人数字证书等</span
              >
            </p>
          </td>
        </tr>
        <tr>
          <td
            width="123"
            valign="center"
            style="
              padding: 0px 7px;
              border-left-width: 1px;
              border-left-color: windowtext;
              border-right-width: 1px;
              border-right-color: windowtext;
              border-top: none;
              border-bottom-width: 1px;
              border-bottom-color: windowtext;
            "
          >
            <p style="font-family: Calibri; font-size: 14px">
              <span style="font-family: 微软雅黑; font-size: 14px"
                >个人健康生理信息</span
              >
            </p>
          </td>
          <td
            width="431"
            valign="center"
            style="
              padding: 0px 7px;
              border-left: none;
              border-right-width: 1px;
              border-right-color: windowtext;
              border-top: none;
              border-bottom-width: 1px;
              border-bottom-color: windowtext;
            "
          >
            <p style="font-family: Calibri; font-size: 14px">
              <span style="font-family: 微软雅黑; font-size: 14px"
                >个人因生病医治等产生的相关记录，如病症、住院志、医嘱单、检验报告、手术及麻醉记录、护理记录、用药记录、药物食物过敏信息、生育信息、以往病史、诊治情况、家族病史、现病史、传染病史等，以及与个人身体健康状况相关的信息，如体重、身高、肺活量等</span
              >
            </p>
          </td>
        </tr>
        <tr>
          <td
            width="123"
            valign="center"
            style="
              padding: 0px 7px;
              border-left-width: 1px;
              border-left-color: windowtext;
              border-right-width: 1px;
              border-right-color: windowtext;
              border-top: none;
              border-bottom-width: 1px;
              border-bottom-color: windowtext;
            "
          >
            <p style="font-family: Calibri; font-size: 14px">
              <span style="font-family: 微软雅黑; font-size: 14px"
                >个人教育工作信息</span
              >
            </p>
          </td>
          <td
            width="431"
            valign="center"
            style="
              padding: 0px 7px;
              border-left: none;
              border-right-width: 1px;
              border-right-color: windowtext;
              border-top: none;
              border-bottom-width: 1px;
              border-bottom-color: windowtext;
            "
          >
            <p style="font-family: Calibri; font-size: 14px">
              <span style="font-family: 微软雅黑; font-size: 14px"
                >个人职业、职位、工作单位、学历、学位、教育经历、工作经历、培训记录、成绩单等</span
              >
            </p>
          </td>
        </tr>
        <tr>
          <td
            width="123"
            valign="center"
            style="
              padding: 0px 7px;
              border-left-width: 1px;
              border-left-color: windowtext;
              border-right-width: 1px;
              border-right-color: windowtext;
              border-top: none;
              border-bottom-width: 1px;
              border-bottom-color: windowtext;
            "
          >
            <p style="font-family: Calibri; font-size: 14px">
              <span style="font-family: 微软雅黑; font-size: 14px"
                >个人财产信息</span
              >
            </p>
          </td>
          <td
            width="431"
            valign="center"
            style="
              padding: 0px 7px;
              border-left: none;
              border-right-width: 1px;
              border-right-color: windowtext;
              border-top: none;
              border-bottom-width: 1px;
              border-bottom-color: windowtext;
            "
          >
            <p style="font-family: Calibri; font-size: 14px">
              <span style="font-family: 微软雅黑; font-size: 14px"
                >银行账户、鉴别信息(口令)、存款信息（包括资金数量、支付收款记录等）、房产信息、信贷记录、征信信息、交易和消费记录、流水记录等，以及虚拟货币、虚拟交易、游戏类兑换码等虚拟财产信息</span
              >
            </p>
          </td>
        </tr>
        <tr>
          <td
            width="123"
            valign="center"
            style="
              padding: 0px 7px;
              border-left-width: 1px;
              border-left-color: windowtext;
              border-right-width: 1px;
              border-right-color: windowtext;
              border-top: none;
              border-bottom-width: 1px;
              border-bottom-color: windowtext;
            "
          >
            <p style="font-family: Calibri; font-size: 14px">
              <span style="font-family: 微软雅黑; font-size: 14px"
                >个人通信信息</span
              >
            </p>
          </td>
          <td
            width="431"
            valign="center"
            style="
              padding: 0px 7px;
              border-left: none;
              border-right-width: 1px;
              border-right-color: windowtext;
              border-top: none;
              border-bottom-width: 1px;
              border-bottom-color: windowtext;
            "
          >
            <p style="font-family: Calibri; font-size: 14px">
              <span style="font-family: 微软雅黑; font-size: 14px"
                >通信记录和内容、短信、彩信、电子邮件，以及描述个人通信的数据（通常称为元数据）等</span
              >
            </p>
          </td>
        </tr>
        <tr>
          <td
            width="123"
            valign="center"
            style="
              padding: 0px 7px;
              border-left-width: 1px;
              border-left-color: windowtext;
              border-right-width: 1px;
              border-right-color: windowtext;
              border-top: none;
              border-bottom-width: 1px;
              border-bottom-color: windowtext;
            "
          >
            <p style="font-family: Calibri; font-size: 14px">
              <span style="font-family: 微软雅黑; font-size: 14px"
                >联系人信息</span
              >
            </p>
          </td>
          <td
            width="431"
            valign="center"
            style="
              padding: 0px 7px;
              border-left: none;
              border-right-width: 1px;
              border-right-color: windowtext;
              border-top: none;
              border-bottom-width: 1px;
              border-bottom-color: windowtext;
            "
          >
            <p style="font-family: Calibri; font-size: 14px">
              <span style="font-family: 微软雅黑; font-size: 14px"
                >通讯录、好友列表、群列表、电子邮件地址列表等</span
              >
            </p>
          </td>
        </tr>
        <tr>
          <td
            width="123"
            valign="center"
            style="
              padding: 0px 7px;
              border-left-width: 1px;
              border-left-color: windowtext;
              border-right-width: 1px;
              border-right-color: windowtext;
              border-top: none;
              border-bottom-width: 1px;
              border-bottom-color: windowtext;
            "
          >
            <p style="font-family: Calibri; font-size: 14px">
              <span style="font-family: 微软雅黑; font-size: 14px"
                >个人上网记录</span
              >
            </p>
          </td>
          <td
            width="431"
            valign="center"
            style="
              padding: 0px 7px;
              border-left: none;
              border-right-width: 1px;
              border-right-color: windowtext;
              border-top: none;
              border-bottom-width: 1px;
              border-bottom-color: windowtext;
            "
          >
            <p style="font-family: Calibri; font-size: 14px">
              <span style="font-family: 微软雅黑; font-size: 14px"
                >指通过日志储存的个人信息主体操作记录，包括网站浏览记录、软件使用记录、点击记录、收藏列表等</span
              >
            </p>
          </td>
        </tr>
        <tr>
          <td
            width="123"
            valign="center"
            style="
              padding: 0px 7px;
              border-left-width: 1px;
              border-left-color: windowtext;
              border-right-width: 1px;
              border-right-color: windowtext;
              border-top: none;
              border-bottom-width: 1px;
              border-bottom-color: windowtext;
            "
          >
            <p style="font-family: Calibri; font-size: 14px">
              <span style="font-family: 微软雅黑; font-size: 14px"
                >个人常用设备信息</span
              >
            </p>
          </td>
          <td
            width="431"
            valign="center"
            style="
              padding: 0px 7px;
              border-left: none;
              border-right-width: 1px;
              border-right-color: windowtext;
              border-top: none;
              border-bottom-width: 1px;
              border-bottom-color: windowtext;
            "
          >
            <p style="font-family: Calibri; font-size: 14px">
              <span style="font-family: 微软雅黑; font-size: 14px"
                >指包括硬件序列号、设备 MAC
                地址、软件列表、唯一设备识别码（如IMEI/Android
                ID/IDFA/OpenUDID/GUID/SIM 卡 IMSI
                信息等）等在内的描述个人常用设备基本情况的信息</span
              >
            </p>
          </td>
        </tr>
        <tr>
          <td
            width="123"
            valign="center"
            style="
              padding: 0px 7px;
              border-left-width: 1px;
              border-left-color: windowtext;
              border-right-width: 1px;
              border-right-color: windowtext;
              border-top: none;
              border-bottom-width: 1px;
              border-bottom-color: windowtext;
            "
          >
            <p style="font-family: Calibri; font-size: 14px">
              <span style="font-family: 微软雅黑; font-size: 14px"
                >个人位置信息</span
              >
            </p>
          </td>
          <td
            width="431"
            valign="center"
            style="
              padding: 0px 7px;
              border-left: none;
              border-right-width: 1px;
              border-right-color: windowtext;
              border-top: none;
              border-bottom-width: 1px;
              border-bottom-color: windowtext;
            "
          >
            <p style="font-family: Calibri; font-size: 14px">
              <span style="font-family: 微软雅黑; font-size: 14px"
                >包括行踪轨迹、精准定位信息、住宿信息、经纬度等</span
              >
            </p>
          </td>
        </tr>
        <tr>
          <td
            width="123"
            valign="center"
            style="
              padding: 0px 7px;
              border-left-width: 1px;
              border-left-color: windowtext;
              border-right-width: 1px;
              border-right-color: windowtext;
              border-top: none;
              border-bottom-width: 1px;
              border-bottom-color: windowtext;
            "
          >
            <p style="font-family: Calibri; font-size: 14px">
              <span style="font-family: 微软雅黑; font-size: 14px"
                >其他信息</span
              >
            </p>
          </td>
          <td
            width="431"
            valign="center"
            style="
              padding: 0px 7px;
              border-left: none;
              border-right-width: 1px;
              border-right-color: windowtext;
              border-top: none;
              border-bottom-width: 1px;
              border-bottom-color: windowtext;
            "
          >
            <p style="font-family: Calibri; font-size: 14px">
              <span style="font-family: 微软雅黑; font-size: 14px"
                >婚史、宗教信仰、 性取向、未公开的违法犯罪记录等</span
              >
            </p>
          </td>
        </tr>
      </tbody>
    </table>
    <p style="font-family: Calibri; font-size: 14px; white-space: normal">
      <span style="font-family: 微软雅黑; font-size: 14px">3、</span
      ><span style="font-family: 微软雅黑; font-size: 14px"
        >“个人敏感信息”：是指一旦泄露、非法提供或滥用可能危害人身或财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息。<a
        ></a><span style="font-family: 微软雅黑">本定义出自于</span>GB/T
        35273-2020《信息安全技术
        个人信息安全规范》，以下为个人敏感信息示例（非京东金融</span
      ><span style="font-family: 微软雅黑; font-size: 14px">APP</span
      ><span style="font-family: 微软雅黑; font-size: 14px"
        ><span style="font-family: 微软雅黑"
          >或网站所收集的个人信息，仅作示例说明）：</span
        ></span
      >
    </p>
    <table width="100%">
      <tbody>
        <tr class="firstRow">
          <td
            width="553"
            valign="top"
            colspan="2"
            style="
              padding: 0px 7px;
              border-width: 1px;
              border-color: windowtext;
            "
          >
            <p
              style="text-align: center; font-family: Calibri; font-size: 14px"
            >
              <strong
                ><span style="font-family: 微软雅黑; font-size: 14px"
                  >个人敏感信息举例</span
                ></strong
              >
            </p>
          </td>
        </tr>
        <tr>
          <td
            width="123"
            valign="center"
            style="
              padding: 0px 7px;
              border-left-width: 1px;
              border-left-color: windowtext;
              border-right-width: 1px;
              border-right-color: windowtext;
              border-top: none;
              border-bottom-width: 1px;
              border-bottom-color: windowtext;
            "
          >
            <p style="font-family: Calibri; font-size: 14px">
              <span style="font-family: 微软雅黑; font-size: 14px"
                >个人财产信息</span
              >
            </p>
          </td>
          <td
            width="431"
            valign="center"
            style="
              padding: 0px 7px;
              border-left: none;
              border-right-width: 1px;
              border-right-color: windowtext;
              border-top-width: 1px;
              border-top-color: windowtext;
              border-bottom-width: 1px;
              border-bottom-color: windowtext;
            "
          >
            <p style="font-family: Calibri; font-size: 14px">
              <span style="font-family: 微软雅黑; font-size: 14px"
                >银行账户、鉴别信息(口令)、存款信息（包括资金数量、支付收款记录等）、房产信息、信贷记录、征信信息、交易和消费记录、流水记录等，以及虚拟货币、虚拟交易、游戏类兑换码等虚拟财产信息</span
              >
            </p>
          </td>
        </tr>
        <tr>
          <td
            width="123"
            valign="center"
            style="
              padding: 0px 7px;
              border-left-width: 1px;
              border-left-color: windowtext;
              border-right-width: 1px;
              border-right-color: windowtext;
              border-top: none;
              border-bottom-width: 1px;
              border-bottom-color: windowtext;
            "
          >
            <p style="font-family: Calibri; font-size: 14px">
              <span style="font-family: 微软雅黑; font-size: 14px"
                >个人健康生理信息</span
              >
            </p>
          </td>
          <td
            width="431"
            valign="center"
            style="
              padding: 0px 7px;
              border-left: none;
              border-right-width: 1px;
              border-right-color: windowtext;
              border-top: none;
              border-bottom-width: 1px;
              border-bottom-color: windowtext;
            "
          >
            <p style="font-family: Calibri; font-size: 14px">
              <span style="font-family: 微软雅黑; font-size: 14px"
                >个人因生病医治等产生的相关记录，如病症、住院志、医嘱单、检验报告、手术及麻醉记录、护理记录、用药记录、药物食物过敏信息、生育信息、以往病史、诊治情况、家族病史、现病史、传染病史等</span
              >
            </p>
          </td>
        </tr>
        <tr>
          <td
            width="123"
            valign="center"
            style="
              padding: 0px 7px;
              border-left-width: 1px;
              border-left-color: windowtext;
              border-right-width: 1px;
              border-right-color: windowtext;
              border-top: none;
              border-bottom-width: 1px;
              border-bottom-color: windowtext;
            "
          >
            <p style="font-family: Calibri; font-size: 14px">
              <span style="font-family: 微软雅黑; font-size: 14px"
                >个人生物识别信息</span
              >
            </p>
          </td>
          <td
            width="431"
            valign="center"
            style="
              padding: 0px 7px;
              border-left: none;
              border-right-width: 1px;
              border-right-color: windowtext;
              border-top: none;
              border-bottom-width: 1px;
              border-bottom-color: windowtext;
            "
          >
            <p style="font-family: Calibri; font-size: 14px">
              <span style="font-family: 微软雅黑; font-size: 14px"
                >个人基因、指纹、声纹、掌纹、耳廓、虹膜、面部识别特征等</span
              >
            </p>
          </td>
        </tr>
        <tr>
          <td
            width="123"
            valign="center"
            style="
              padding: 0px 7px;
              border-left-width: 1px;
              border-left-color: windowtext;
              border-right-width: 1px;
              border-right-color: windowtext;
              border-top: none;
              border-bottom-width: 1px;
              border-bottom-color: windowtext;
            "
          >
            <p style="font-family: Calibri; font-size: 14px">
              <span style="font-family: 微软雅黑; font-size: 14px"
                >个人身份信息</span
              >
            </p>
          </td>
          <td
            width="431"
            valign="center"
            style="
              padding: 0px 7px;
              border-left: none;
              border-right-width: 1px;
              border-right-color: windowtext;
              border-top: none;
              border-bottom-width: 1px;
              border-bottom-color: windowtext;
            "
          >
            <p style="font-family: Calibri; font-size: 14px">
              <span style="font-family: 微软雅黑; font-size: 14px"
                >身份证、军官证、护照、驾驶证、工作证、社保卡、居住证等</span
              >
            </p>
          </td>
        </tr>
        <tr>
          <td
            width="123"
            valign="center"
            style="
              padding: 0px 7px;
              border-left-width: 1px;
              border-left-color: windowtext;
              border-right-width: 1px;
              border-right-color: windowtext;
              border-top: none;
              border-bottom-width: 1px;
              border-bottom-color: windowtext;
            "
          >
            <p style="font-family: Calibri; font-size: 14px">
              <span style="font-family: 微软雅黑; font-size: 14px"
                >其他信息</span
              >
            </p>
          </td>
          <td
            width="431"
            valign="center"
            style="
              padding: 0px 7px;
              border-left: none;
              border-right-width: 1px;
              border-right-color: windowtext;
              border-top: none;
              border-bottom-width: 1px;
              border-bottom-color: windowtext;
            "
          >
            <p style="font-family: Calibri; font-size: 14px">
              <span style="font-family: 微软雅黑; font-size: 14px"
                >性取向、婚史、宗教信仰、未公开的违法犯罪记录、通信记录和内容、通讯录、好友列表、群组列表、行踪轨迹、网页浏览记录、住宿信息、精准定位信息等</span
              >
            </p>
          </td>
        </tr>
      </tbody>
    </table>
    <p style="font-family: Calibri; font-size: 14px; white-space: normal">
      <span style="font-family: 微软雅黑; font-size: 14px">&nbsp;</span>
    </p>
    <p class="text strong">
      注：本政策版本更新日期为2022年4月24日，本版政策更新内容主要如下：
    </p>
    <p class="text strong">1、增加1个权限调取。删除2个不再使用的权限。</p>
    <p class="text strong">
      2、增加部分服务场景收集个人信息依据的法律法规名称。
    </p>
    <p class="text strong">
      我们还会将<a
        href="https://h5.m.jd.com/babelDiy/Zeus/nnD68tgCAS9xwR2TAscMWMjkaKw/index.html"
        >上一版本的隐私政策</a
      >存档，供您查阅。
    </p>
    <p>
      <br />
    </p>
  </div>
  <Footer/>
</div>
</template>
<script>
import InfoHeader from './info-header.vue'
import Footer from './footer.vue'
export default {
  name: "Privacy",
  components:{
    InfoHeader,
    Footer
  }
};
</script>
<style scoped>
.privacy-body{
  width: 100%;
  overflow-x: hidden;
  background-color: #f9f9f9;
}
.jm-protocol {
  /* margin: 16px;
  font-family: 微软雅黑; */
  width: 1132px;
  padding-top: 32px;
  margin: auto;
  color: #333333;
}

.jm-protocol p {
  margin: 14px 0;
}
.jm-protocol a {
  color: rgba(0, 0, 255, 1)!important;
}
.jm-protocol table,.jm-protocol th, .jm-protocol td
{
    border: 1px solid black;
}

.jm-protocol table td {
  word-break: break-all;
}

.jm-protocol table {
  font-size: 14px;
  background-color: #333;
  width: 100%;
}

.jm-protocol table td {
  vertical-align: middle;
  background-color: #fff;
}

.jm-protocol .title {
  font-size: 18px;
  text-align: center;
  font-weight: bolder;
}

.jm-protocol .text {
  font-size: 14px;
}

.jm-protocol a {
  text-decoration: underline;
  color: #4f4f64;
}

.jm-protocol .strong {
  font-weight: bolder;
}
table{
      border-collapse: collapse;
    border-spacing: 0;
}
</style>